/*
 * @Author: Tina Huang
 * @Date: 2024-11-07 14:02:38
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2025-10-23 14:59:52
 * @Description:
 */
export type PickType = {
  id: number
  title: string
  link?: string
  hasDetail?: boolean
  detail?: string
  code?: string
  cover?: string
  color?: string
  description?: string
  direction?: string
  pay?: number
  off?: number
  off_date?: string
  keywords?: string[]
  video?: string
  pay_img?: string
  forward?: boolean
  hide?: boolean
  rlink?: string
  full_title?: string
  m_pay_link?: string
  lock?: boolean
  pay_link?: string
  has_specs?: boolean
  specs?: any[]
  hot?: boolean
  top?: boolean
  lasted?: boolean
  images?: string[]
  flowus?: boolean
  created?: string
  activity?: string
  home?: boolean // 首页专栏
  extra?: any
  link_buy?: boolean
}

type PickPreview = {
  title: string
  tag: string
  desc: string[]
  cover: string
  btn: string
  icon: string
  path: string
}

export const Picks: PickType[] = [
  {"id": 103,"direction": "col","title": "🔥 打工人自救指南！Notion高效工作台","full_title": "","description": "","detail": "现在每周任务清晰到分钟，错误率↓50%，准时下班不是梦！”<br><br>• 自动统计“已完成/进行中/待开始”，一眼看穿拖延任务<br>• 自动标红“即将逾期”任务（再也不会忘改Bug！）<br>• 时间轴视图+优先级排序，重要事项永远置顶","code": "","pay": 7.9,"off": 0,"off_date": "","cover": "./assets/templates/workspace_2025/1.png","keywords": ["工作管理","效率提升"],"video": "//player.bilibili.com/player.html?isOutside=true&aid=114960034236490&bvid=BV1o8hPzTEfA&cid=31448763193&p=1","m_pay_link": "https://e.tb.cn/h.SRwVqBw27csi3Sb?tk=AWCufc5eQ8I","images":["./assets/templates/workspace/2.png","./assets/templates/workspace/3.png","./assets/templates/workspace/4.png","./assets/templates/workspace/5.png","./assets/templates/workspace/6.png","./assets/templates/workspace/7.png","./assets/templates/workspace/8.png"],"pay_link": "","activity": "","created": "1760691180000","flowus": false,"rlink":""},
  {"id": 102,"direction": "col","title": "📚 Notion课程管理神器！一键追踪课节+费用","full_title": "","description": "✅ 一键记录课程<br>- 板块分明，界面超清晰！<br>- 点击按钮直接 「排课」or「添加上课记录」，懒人必备～<br>✅ 日历视图+自动统计<br>- 所有课程在日历上直观显示，拖拽就能调整时间<br>- 自动计算剩余课节（买20节，上5节，剩余15节一目了然）<br>✅ 费用追踪透明化<br>- 累计花费、单节课费用自动汇总，再也不用担心超支！<br>---<br><br>💡 为什么好用？<br>▸ 操作极简：按钮预设模板，3秒完成记录<br>▸ 全自动统计：公式/Rollup联动，数据零误差<br>▸ 多端同步：手机/平板随时查看，上课党/老师都适用!","detail": "","cover": "./assets/templates/couse_schedule/1.png","keywords": ["日程安排","数据统计"],"link": "https://httishere666.notion.site/2486018c38ee8098993cdd9bca15c3a7","code": "","flowus": false,"images":["./assets/templates/couse_schedule/2.png","./assets/templates/couse_schedule/3.png","./assets/templates/couse_schedule/4.png","./assets/templates/couse_schedule/5.png","./assets/templates/couse_schedule/6.png","./assets/templates/couse_schedule/7.png","./assets/templates/couse_schedule/8.png"],"created": "1760690880000","rlink":""},
  {"id": 101,"direction": "col","title": "🐮 科研党必备｜Notion打造高效文献管理体系","full_title": "","description": "你是不是也这样？<br><br>❌ 文献越存越多，找起来像大海捞针<br>❌ 读完就忘，写论文时死活想不起关键观点<br>❌ 分类混乱，导师突然要资料时手忙脚乱<br><br>在这里一站式解决所有问题！","detail": "1️⃣ 智能文献数据库<br>✔️ 基础信息记录标题/作者/期刊/关键词<br>✔️ 状态标记（未读/精读/已读）<br>✔️ 优先级分类，重要文献一眼锁定<br><br>2️⃣ 结构化阅读笔记<br>✔️ 核心观点+创新点+局限性分区记录<br>✔️ 支持代码块/公式插入（理工科友好！）<br>✔️ 关联相关课题，构建知识网络<br><br>3️⃣ 可视化追踪<br>✔️ 自动统计文献阅读数量<br>✔️ 论文任务完成情况","code": "","pay": 5.8,"off": 0,"off_date": "","cover": "./assets/templates/paper_2025/1.png","keywords": ["学习计划","科研必备"],"video": "//player.bilibili.com/player.html?isOutside=true&aid=114946931165262&bvid=BV1R78yzCEQV&cid=31398167243&p=1","m_pay_link": "https://e.tb.cn/h.SR7afJ8RfOZ3QuD?tk=SziEfcUIGeY","images":["./assets/templates/paper_2025/2.png","./assets/templates/paper_2025/3.png","./assets/templates/paper_2025/4.png","./assets/templates/paper_2025/5.png","./assets/templates/paper_2025/6.png"],"pay_link": "","activity": "","created": "1760690400000","flowus": false,"rlink":""},
  {
    id: 100,
    direction: 'col',
    title: '📱 数据不会说谎？！电子资产全周期管理',
    full_title: '',
    description: '',
    detail:
      '作为数码控和效率达人，今天要分享一个我精心设计的Notion电子资产管理模版！这个模版不仅能记录你的每一件电子产品的购买信息，还能自动计算拥有天数、每日使用成本，帮你汇总统计所有设备的价值和成本情况。<br>全生命周期记录：从购买日期到退役时间，完整记录每件电子产品的使用轨迹<br>智能成本计算：自动计算每日使用成本，让你清楚知道这件设备值不值得买，是否为不必要花费<br>退役管理功能：记录设备转卖、退役状态，管理你的回血状态',
    code: '',
    pay: 5.8,
    off: 0,
    off_date: '',
    cover: './assets/templates/digital/1.png',
    keywords: ['资产管理', '数据管理'],
    video: '//player.bilibili.com/player.html?isOutside=true&aid=114941646474514&bvid=BV1gzhwzWEoX&cid=31378899352&p=1',
    m_pay_link: 'https://e.tb.cn/h.SRSoYJDswFmJtf8?tk=m8JDfcU7JoJ',
    has_specs: true,
    specs: [
      { title: 'Notion版', price: 5.8, remark: '', link: '', content: '' },
      {
        title: 'FlowUs版',
        price: 4.8,
        remark: '直接在页面内进行订阅使用（订阅后请在自己的知识库打开并导入空间）',
        link: 'https://flowus.cn/httishere/share/13cb184e-c0c9-4290-af80-2db4a608bcf7?code=YJDF4B',
        content: '',
      },
    ],
    images: ['./assets/templates/digital/2.png', './assets/templates/digital/3.png', './assets/templates/digital/4.png'],
    pay_link: '',
    activity: '',
    created: '1760689380000'},
  {"id": 99,"direction": "col","title": "🌟 新手友好の高颜值又好用8月计划","full_title": "","description": "","detail": "🌈 3套配色任选！总有一款戳中你。<br>🍃 绿粉少女心 · 🧀 黄蓝活力款· 🎆 灰紫ins风<br>✨ 为什么新手可闭眼使用？<br>✔️ 极简操作：自带「模板按钮」点一下自动生成今日打卡，没有复杂的数据库操作，着重于文字记录<br>✔️ 双视图切换：清单模式复盘/画廊模式打卡，随心使用<br>✔️ 治愈系分区：书单影单+周总结+心情日记，生活痕迹全留存<br>✔️ 移动端适配：窄屏也能流畅操作，通勤路上随时记录<br>👇 小白食用指南<br>1️⃣ 导入母版后「创建副本」（防误删！）<br>2️⃣ 按教程修改日期/打卡项（5分钟搞定）","cover": "./assets/templates/2025-simple-month/0.JPG","keywords": ["月度复盘","个人自律"],"link": "https://flowus.cn/httishere/share/d47674ea-697b-46ee-a762-821b0d7e23da?code=YJDF4B","code": "","flowus": true,"images":["./assets/templates/2025-simple-month/1.png","./assets/templates/2025-simple-month/2.png","./assets/templates/2025-simple-month/3.png","./assets/templates/2025-simple-month/4.png","./assets/templates/2025-simple-month/5.png","./assets/templates/2025-simple-month/6.png","./assets/templates/2025-simple-month/7.png"],"created": "1754056920000","rlink":""},
  {
    id: 98,
    direction: 'col',
    title: '🌟 新手友好の高颜值又好用8月计划',
    full_title: '',
    description: '',
    detail:
      '🌈 3套配色任选！总有一款戳中你。<br>🍃 绿粉少女心 · 🧀 黄蓝活力款· 🎆 灰紫ins风<br>✨ 为什么新手可闭眼使用？<br>✔️ 极简操作：自带「模板按钮」点一下自动生成今日打卡，没有复杂的数据库操作，着重于文字记录<br>✔️ 双视图切换：清单模式复盘/画廊模式打卡，随心使用<br>✔️ 治愈系分区：书单影单+周总结+心情日记，生活痕迹全留存<br>✔️ 移动端适配：窄屏也能流畅操作，通勤路上随时记录<br>👇 小白食用指南<br>1️⃣ 导入母版后「创建副本」（防误删！）<br>2️⃣ 按教程修改日期/打卡项（5分钟搞定）',
    cover: './assets/templates/2025-simple-month/0.JPG',
    keywords: ['月度复盘', '个人自律'],
    link: 'https://httishere666.notion.site/23e6018c38ee8039bc48ed524933d669',
    code: '',
    flowus: false,
    images: [
      './assets/templates/2025-simple-month/1.png',
      './assets/templates/2025-simple-month/2.png',
      './assets/templates/2025-simple-month/3.png',
      './assets/templates/2025-simple-month/4.png',
      './assets/templates/2025-simple-month/5.png',
      './assets/templates/2025-simple-month/6.png',
      './assets/templates/2025-simple-month/7.png',
    ],
    created: '1754056560000',
    rlink: '',
  },
  {
    id: 97,
    direction: 'col',
    title: '💰 超全财务管理',
    full_title: '🔥超全财务管理模板！帮你轻松掌控资产情况',
    description: '',
    detail:
      '💰 存钱难？投资乱？预算超支？债务混乱？<br><br>别慌！这个 Notion财务管理模板 帮你一次搞定！📝✨<br><br>🌟 核心功能：<br><br>✅ 资产管理：清晰记录所有资产，净资产一目了然！<br><br>✅ 投资理财管理：跟踪理财产品、投资项目，收益实时掌控！📈<br><br>✅ 存钱目标管理：三种存钱法（不定期存钱 / 365天存钱 / 12个月存单法），让你科学攒钱！🏦<br><br>✅ 年度报表 & 预算：全年的收入、支出、储蓄目标，一键掌握！📊<br><br>✅ 购物清单：培养延迟满足力，不冲动消费！🛍️<br><br>✅ 债务管理：轻松规划还款计划，减少财务压力！💳<br><br>📌 特别亮点：<br><br>✨ 数据可视化看板，净资产、投资、存款、债务…一键查看！<br><br>✨ 自定义资产计算，是否计入数字资产 / 债务，自己决定！',
    code: '',
    pay: 9.9,
    off: 0,
    off_date: '',
    cover: './assets/templates/2025-finance/1.JPG',
    keywords: ['财务管理', '效率提升', '自动化数据总结'],
    video: '',
    m_pay_link: 'https://e.tb.cn/h.hM7QXQ5xUzZXkip?tk=uNYU45Cv92k',
    has_specs: true,
    specs: [
      {
        title: '尝鲜版',
        price: 0,
        remark: '',
        link: 'https://httishere666.notion.site/1b96018c38ee8003999dd0f2f9c8c377?duplicate=true',
        content: '',
      },
      { title: '正式版', price: 9.9, remark: '', link: '', content: '' },
    ],
    images: [
      './assets/templates/2025-finance/2.JPG',
      './assets/templates/2025-finance/3.JPG',
      './assets/templates/2025-finance/4.JPG',
      './assets/templates/2025-finance/5.JPG',
      './assets/templates/2025-finance/6.JPG',
      './assets/templates/2025-finance/7.JPG',
      './assets/templates/2025-finance/8.JPG',
      './assets/templates/2025-finance/9.JPG',
      './assets/templates/2025-finance/10.JPG',
    ],
    pay_link: '',
    activity: '',
    created: '1754056080000',
    flowus: false,
    rlink: '',
  },
  {
    id: 96,
    direction: 'col',
    title: '✨ 观影清单记录',
    full_title: '🎬高效管理观影记录！Notion打造电子影单',
    description: '',
    detail:
      '你是不是也有这样的烦恼——<br>✨ 看过的电影总是忘记剧情？<br>✨ 想找一部电影，却记不清有没有看过？<br>✨ 计划的观影清单，总是看了一半就忘？<br><br>别担心，他可以帮你系统化管理观影习惯，让每一部电影都能被好好收藏！💡<br><br>📌 亮点：<br><br>🎞 观影清单｜记录想看的 & 已看的电影，轻松管理片单<br><br>⏳ 观影计时｜统计观影时间，看看你到底花了多少时间在电影上<br><br>📊 年度汇总｜自动统计年度观影总数、评分分布、最爱电影，一目了然<br><br>📌 进度管理｜剧集进度一键标记，告别“追剧断片”🚀<br><br>无论你是电影爱好者、影评人，还是想简单记录观影体验，这个模版都能助你一臂之力！💯<br><br>一起打造属于自己的电影宇宙吧！',
    code: '',
    pay: 9.9,
    off: 0,
    off_date: '',
    cover: './assets/templates/2025-watching-space/1.JPG',
    keywords: ['效率提升', '生活管理'],
    video: '',
    m_pay_link: 'https://e.tb.cn/h.hM7VfnCObOwz2lp?tk=37lz45CMRAp',
    images: [
      './assets/templates/2025-watching-space/2.JPG',
      './assets/templates/2025-watching-space/3.JPG',
      './assets/templates/2025-watching-space/4.JPG',
    ],
    pay_link: '',
    activity: '',
    created: '1754055600000',
    flowus: false,
    rlink: '',
  },
  {
    id: 95,
    direction: 'col',
    title: '📅 月度计划3.0',
    full_title: '',
    description: '',
    detail:
      '帮助你把整个 月度目标 和 日常习惯 都一目了然地掌控住，轻松追踪进展，实现更多目标！🚀<br><br>✨ 模板亮点：<br><br>可视化月度看板 📊：通过进度条和统计数据，快速了解本月各项目标完成情况，随时调整行动计划。<br><br>目标管理 🎯：无论是长期目标，还是短期目标，都可以清晰记录，按优先级进行管理，帮助你聚焦最重要的任务。<br><br>每日打卡 ✅：养成好习惯，从每天的小打卡做起，记录进展，享受每一份努力带来的成就感。<br><br>旅行探索 ✈️：记录每一段旅行足迹和探索的地方，让每次旅行成为记忆的宝贵财富。<br><br>阅读与观影 📚🎬：记录你读过的书籍和看过的电影，定期回顾，分享心得。<br><br>运动记录 💪：跟踪每次运动的时长、种类和消耗的热量，保持健康的生活习惯。<br><br>习惯养成 🌱：帮助你养成好习惯，记录每一天的小进步，慢慢积累，改变从细节开始。<br><br>无论你是要提升效率，还是想要在日常生活中更有规划，这个模板都能帮助你更好地管理时间和目标，轻松变得更自律！让你的目标和生活更有条理，开始改变吧！<br>',
    code: '',
    pay: 21.9,
    off: 0,
    off_date: '',
    cover: './assets/templates/月度计划3.0/1.JPG',
    keywords: ['个人管理', '月度复盘', '自动化数据总结', '时间管理', '个人自律'],
    video: '',
    m_pay_link: 'https://e.tb.cn/h.hMkH97QavaLl70I?tk=RFBC45Chk92',
    images: [
      './assets/templates/月度计划3.0/2.JPG',
      './assets/templates/月度计划3.0/3.JPG',
      './assets/templates/月度计划3.0/4.JPG',
      './assets/templates/月度计划3.0/5.JPG',
      './assets/templates/月度计划3.0/6.JPG',
    ],
    pay_link: '',
    activity: '可好评送模版',
    created: '1754054340000',
    flowus: false,
    rlink: '',
  },
  {
    id: 94,
    direction: 'col',
    title: '🔥 Project 50挑战',
    full_title: '🔥 爆火Project 50挑战｜坚持50天你会得到…？！',
    description: '',
    detail:
      '❓ 什么是PROJECT 50？<br>是一种自我挑战项目，通常为期50天，帮助我们突破舒适区，提升自律性，并在这段时间内对身体、心理和生活习惯做出积极改变。然后我会选择第10天，第25天，第38天和第50天作为我的里程碑来检验自己的坚持情况。',
    cover: './assets/templates/project50.jpg',
    keywords: ['个人管理', '个人自律', '习惯打卡'],
    link: 'https://httishere666.notion.site/19e6018c38ee801085cfcd2465ca5b69',
    code: '',
    flowus: false,
    created: '1740548400000',
    rlink: '',
    top: true,
  },
  {
    id: 89,
    direction: 'col',
    title: '🎉 FlowUs｜2025年度计划',
    full_title: '',
    description: '<strong><br />❗️ 点击模版订阅获取导入模版到自己空间，订阅购买前请确保自己有足够的空间和拷贝次数</strong>',
    detail: '',
    code: '',
    pay: 7.8,
    off: 0,
    off_date: '',
    cover: './assets/templates/flowus-2025.jpg',
    keywords: ['年度计划', '个人自律', '月度计划', '复盘记录'],
    video: '',
    m_pay_link: '',
    has_specs: true,
    specs: [
      {
        title: '尝鲜版',
        price: 0,
        remark: '',
        link: 'https://flowus.cn/httishere/share/62e7142e-5553-4be9-b8e1-2f4b1870fd43?code=YJDF4B',
        content: '',
      },
      {
        title: '适用PC版',
        price: 7.8,
        remark: '',
        link: 'https://flowus.cn/httishere/share/4bd54f49-8fea-4bd1-91d0-82bd7c1198a9?code=YJDF4B',
        content: '',
      },
      {
        title: '适用平板版',
        price: 7.8,
        remark: '',
        link: 'https://flowus.cn/httishere/share/130eeb38-6241-476d-ab7b-5630bc71d05e?code=YJDF4B',
        content: '',
      },
    ],
    pay_link: '',
    activity: '',
    created: '1740457140000',
    flowus: true,
    rlink: '',
  },
  {
    id: 93,
    direction: 'col',
    title: '👊 FlowUs｜停止拖延的GTD',
    full_title: '👊 停止拖延的秘诀｜用GTD任务管理提高生产力',
    description: '',
    detail: '',
    cover: './assets/templates/flowus-gtd.jpg',
    keywords: ['效率提升'],
    link: 'https://flowus.cn/httishere/share/2bb1a0d8-7a32-447b-8901-f3a01df9778a?code=YJDF4B',
    code: '',
    flowus: true,
    created: '1740458640000',
    rlink: '',
  },
  {
    id: 92,
    direction: 'col',
    title: '🎧 FlowUs｜播客听听听',
    full_title: '',
    description: '',
    detail: '',
    cover: './assets/templates/flowus-padcast.jpg',
    keywords: ['自我提升', '播客笔记'],
    link: 'https://flowus.cn/httishere/share/3f15427c-3b94-45fa-b2a8-6fbb56fdf243?code=YJDF4B',
    code: '',
    flowus: true,
    created: '1740457980000',
    rlink: '',
  },
  {
    id: 91,
    direction: 'col',
    title: '✔️ FlowUs｜2025结果清单布局',
    full_title: '',
    description: '',
    detail: '',
    cover: './assets/templates/2025-bj/1.png',
    keywords: ['小白可用', '个人管理'],
    link: 'https://flowus.cn/httishere/share/28cf1738-b693-445e-941c-0c727fcc5d25?code=YJDF4B',
    code: '',
    flowus: true,
    images: ['./assets/templates/2025-bj/2.png'],
    created: '1740457800000',
    rlink: '',
  },
  {
    id: 90,
    direction: 'row',
    title: '🔥 FlowUs｜周计划·用2%的时间看见自己',
    full_title: '',
    description: '<strong><br />❗️ 点击模版订阅获取导入模版到自己空间，订阅购买前请确保自己有足够的空间和拷贝次数</strong>',
    detail: '',
    code: '',
    pay: 2.5,
    off: 0,
    off_date: '',
    cover: './assets/templates/flowus-2025-week.png',
    keywords: ['每周计划', '待办管理', '高能量'],
    video: '',
    m_pay_link: '',
    pay_link: '',
    activity: '',
    created: '1740457200000',
    flowus: true,
    rlink: '',
  },
  {
    id: 88,
    direction: 'col',
    title: '🌟 FlowUs｜整理星人的救星·打造自己的线上衣橱',
    full_title: '',
    description:
      '<strong style="color: darkred; "><br />❗️ 点击模版订阅获取导入模版到自己空间，订阅购买前请确保自己有足够的空间和拷贝次数</strong>',
    detail: '',
    code: '',
    pay: 3.5,
    off: 0,
    off_date: '',
    cover: './assets/templates/flowus-wardrobe.png',
    keywords: ['生活管理', '物品管理'],
    video: '',
    activity: '点击去购买预览模版',
    created: '1740456300000',
    flowus: true,
    pay_link: 'https://flowus.cn/httishere/share/622a74fc-7835-49ba-bbd5-42a37ae90baa?code=YJDF4B',
  },
  {
    id: 87,
    direction: 'col',
    title: '🎯 用结构清单布局2025',
    full_title: '',
    description:
      '从8个方面设定自己的主要愿景/结果，然后从这些结果一步步详化执行任务，我之前看到说做Not todo list比做todo list更有效，做结果清单比做目标计划更有效，通常在使用手帐本的时候年度报告总会有“今年到过哪些记忆深刻的地方？”，“今年自己有什么成果/成就”，但是每每做年度复盘的时候总是发现这些自己根本没有东西可以写，就是因为以往设定的目标总是一个又大又宽泛的事情，实际上是很难去实际实地的完成，所以和我一样从现在开始给自己设定一些有挑战性但是不会太困难的目标吧！<br><br>1. 确定好一定要在年度复盘里可以看到能带给自己成就感的事件，然后着重去完成。<br><br>2. 对于目标一定要详化具体的执行任务，否则一个空泛的目标是很难让人产生动力的。<br><br>3. 设定目标截止日期和相应的奖励，能让自己有一定的紧迫感能更有动力更好的执行。<br><br>一定相信，2025年你会成为更好的自己！',
    detail: '',
    cover: './assets/templates/2025-bj/1.png',
    keywords: ['个人管理', '年度计划', 'P人可用'],
    link: 'https://httishere666.notion.site/2025-1666018c38ee802da414ff8a499b917e?pvs=4',
    code: '',
    flowus: false,
    images: ['./assets/templates/2025-bj/2.png'],
    created: '1737614460000',
    rlink: '',
  },
  {
    id: 86,
    direction: 'col',
    title: '💖 2025年度计划',
    full_title: '💖 2025年度计划｜新的一年请继续闪闪发光吧',
    description: '',
    detail:
      '不知不觉，2024迎来了尾声，我们也又到了一年一度的年度计划时刻，不知道大家2024目标完成的怎么样的，每次到做年度计划的时候我都特别开心，因为又可以摆脱这个摆烂的2024，开始展望新的一年，开始设计新的方向。<br>这次年度计划涵盖了目标管理、习惯打卡、月/周/日计划、愿景板以及时间管理等多个模块，让你在新的一年里更加自律，高效发展自我！✨<br><br>🔥 亮点：<br><br>🎯 目标管理：设定年度目标，分解到月、周、日，实现逐步达成。<br><br>✅ 习惯打卡：每日习惯养成，打卡功能助你保持动力，坚持到底，并引入月度打卡热力帮你更好的可视化打卡执行情况。<br><br>📆 月/周/日计划：详细的计划安排，能让每一天都过得充实有序，每天只需要花费2%时间去记录，就可以轻松剖析和看到自己。<br><br>📋 愿景板：记录你各个领域的愿景与梦想，时刻激励自己前行。<br><br>⏰ 时间管理：科学规划时间，提高工作和生活效率。<br><br>💡 更多奇思妙想：在本模版中引入了很多阿汪自己的奇思妙想，事项标题高亮，月日历（日程标记），睡眠可视化时间轴，情绪打卡，这些都可以帮助在新的一年里更加闪闪发光。<br><br><br>让你的新年不再只是开始时的雄心壮志，而是全年的坚持与进步。希望大家都能在新的一年里更加自律，高效实现自己的目标！让2025成为你最闪闪发光的一年！💫',
    code: '',
    pay: 15.9,
    off: 3,
    off_date: '2024/12/24 23:59',
    cover: './assets/templates/2025-year/cover.PNG',
    keywords: ['年度计划', '人生管理'],
    video: '//player.bilibili.com/player.html?isOutside=true&aid=113672131184931&bvid=BV15YkFYzEvb&cid=27400013053&p=1',
    m_pay_link: 'http://e.tb.cn/h.TgsTmBg9nc6ZMCk?tk=uc1I3z8xp5g',
    has_specs: true,
    specs: [
      {
        title: '⭐️ 特别尝鲜版',
        price: 0,
        remark: '',
        link: 'https://httishere666.notion.site/1606018c38ee80f09e38da2f97881a12',
        content:
          '尝鲜版说明：含基本功能，不含数据统计，高级可视化等内容<br>【正式版】：模版发布一周内可享上新早鸟价 (-3元)<br>【女生特别版】：12.22 发布上线（含女性管理相关板块）<br>【积分特别版】：12.24 发布上线（用积分丈量生活）<br><br>关于模版升级，购买常规版或者进阶版的小伙伴可在购买模版后的3个月内补差升级为其他版本',
      },
      { title: '正式常规版', price: 15.9, remark: '', link: '', content: '' },
      { title: '正式进阶版', price: 19.9, remark: '', link: '', content: '' },
      { title: '女生特别版', price: 20.9, remark: '', link: '', content: '' },
      { title: '积分特别版', price: 24.9, remark: '', link: '', content: '' },
    ],
    pay_link: '',
    activity: '【早鸟优惠价】模版上线一周内',
    created: '1734422220000',
    flowus: false,
    rlink: '',
    home: true,
    extra: {
      home: './assets/templates/2025-year/home.jpg',
      pro: './assets/templates/2025-year/pro.png',
    },
  },
  {
    id: 85,
    direction: 'col',
    title: '💜 “紫”定能行｜用FlowUs全力高效备考2026考研',
    full_title: '',
    description: '',
    detail: '',
    code: '',
    pay: 6.9,
    off: 0,
    off_date: '',
    cover: './assets/templates/2026-flowus-kaoyan/11.png',
    keywords: ['考研计划', '备考计划'],
    video: '',
    m_pay_link: 'https://flowus.cn/httishere/share/c6c1dd11-0f32-44e5-8321-8a7945b87346?code=YJDF4B',
    images: [
      './assets/templates/2026-flowus-kaoyan/12.png',
      './assets/templates/2026-flowus-kaoyan/13.png',
      './assets/templates/2026-flowus-kaoyan/14.png',
      './assets/templates/2026-flowus-kaoyan/15.png',
      './assets/templates/2026-flowus-kaoyan/16.png',
    ],
    pay_link: 'https://flowus.cn/httishere/share/c6c1dd11-0f32-44e5-8321-8a7945b87346?code=YJDF4B',
    activity: '',
    created: '1733294940000',
    rlink: '',
    flowus: true,
  },
  {
    id: 84,
    direction: 'col',
    title: '✨ 学期爆改计划',
    full_title: '✨ 爆好用！开学就立马拿出我的学期爆改计划！',
    description:
      '有不少粉丝宝宝应该都开学了，之前每次都会和大家分享新的学期模版，有很多小伙伴觉得每次都要重新购买有些麻烦，所以阿汪决定后面的学期模版都作为开放模版和大家分享～<br>本模版包含了待办管理，课程管理，习惯管理，目标管理等板块，可以更好地帮助大家在上学期间专注学业学习～',
    detail: '',
    cover: './assets/templates/2024-new-term/1.jpg',
    keywords: ['学习计划', '学生计划'],
    link: 'https://httishere666.notion.site/0368b8afe42b40a7896ea2b40fb2fbb6',
    code: '',
    flowus: false,
    images: [
      './assets/templates/2024-new-term/2.jpg',
      './assets/templates/2024-new-term/3.jpg',
      './assets/templates/2024-new-term/4.jpg',
      './assets/templates/2024-new-term/5.jpg',
      './assets/templates/2024-new-term/6.jpg',
      './assets/templates/2024-new-term/7.jpg',
      './assets/templates/2024-new-term/8.jpg',
      './assets/templates/2024-new-term/9.jpg',
    ],
    rlink: '',
    created: '1732867680000',
  },
  {
    id: 83,
    direction: 'col',
    title: '🎉 Notion 2026考研计划',
    full_title: '🎉 Notion 2026考研计划 · 高效备考 · 全程规划',
    description: '🎁 好评福利',
    detail:
      'Hello，大家好，这里是阿汪同学。<br><br>千呼万唤始出来，被问了好久的2026考研学习模版终于产出了，在模版设计上阿汪也是纠结了很多怎么样的形式更适合大家，根据大家的建议在这版我将阶段学习计划和学习任务进行了结合，在实际使用过程中可以根据自己的需要自由拆解任务，并增加了更多的自动化快捷操作，可以帮助大家更好的上手，让你直接爱上计划和学习～<br><br>本次考研计划主要分成：<br><br>📑 考研阶段规划：在这里可以规划每个阶段的大致任务，然后根据阶段可以再细化学习计划。<br><br>📑 阶段学习计划：阶段学习任务是你某一个学习阶段想要完成的事情，在每天学习的时候就可以通过「创建学习任务」规划这一整天的学习内容，且学习任务内会自动汇总统计你所完成的所有学习记录。完成学习可以更新任务数据，了解学习进度。<br><br>📑 学习记录·时间管理：通过学习内容上的「开始」和「结束」按钮可以自动计算我们的学习时长。在学习内容右侧的今日学习情况内也可以查看到今天学习的次数以及学习时长。<br><br>📑 科目任务：在科目的页面内可以进行任务，学习内容，模考记录等内容的记录。<br><br>📑 每日打卡：一周的打卡记录，打卡之后会自动计算完成率，修改打卡项时可以在公式内进行调整。',
    code: '',
    pay: 8.8,
    off: 1,
    off_date: '2024/11/04 00:00:00',
    cover: './assets/templates/2026-kaoyan/1.png',
    keywords: ['备考', '考研', '高效计划'],
    video: '',
    m_pay_link: 'http://e.tb.cn/h.gCFEmqjHEbkZ59x?tk=4Jx03Mwd1Gj',
    has_specs: true,
    specs: [
      { title: '常规版', price: 8.8, remark: '', link: '', content: '' },
      { title: 'PRO版', price: 10.9, remark: '', link: '', content: '' },
    ],
    images: [
      './assets/templates/2026-kaoyan/2.png',
      './assets/templates/2026-kaoyan/3.png',
      './assets/templates/2026-kaoyan/4.png',
      './assets/templates/2026-kaoyan/5.png',
      './assets/templates/2026-kaoyan/6.png',
      './assets/templates/2026-kaoyan/7.png',
      './assets/templates/2026-kaoyan/8.png',
    ],
    pay_link: '',
    activity: '限时早鸟价，PRO版好评送模版',
    created: '1730179800000',
    rlink: '',
    lasted: true,
  },
  {
    id: 81,
    direction: 'col',
    title: '⚡️ 10月高能量的31件事',
    description: '',
    detail: '',
    cover: './assets/templates/oct-power.jpg',
    keywords: ['高能量'],
    link: 'https://httishere666.notion.site/10-31-1116018c38ee80f69512c24136a9efd4?pvs=4',
    code: '',
    flowus: false,
    images: ['./assets/templates/oct-power/1.png'],
    rlink: '',
  },
  {
    id: 80,
    direction: 'col',
    title: '❌ 拒绝内耗 · 100件能量小事',
    full_title: '',
    description:
      '年初的时候就想着要给自己再做一个高能量清单，但是那时候觉得没有什么想做的事，这段时间看到朋友们都在尝试各种不一样的事情，我也给自己设了一份比较好完成的清单，希望接下去可以努力『做自己』。',
    detail: '',
    pay: 0,
    off: 0,
    off_date: '',
    cover: './assets/templates/100-things.png',
    keywords: ['个人管理', '恢复能量', '自我提升'],
    video: '',
    m_pay_link: '',
    has_specs: true,
    specs: [
      {
        title: 'Notion版',
        price: 0,
        remark: '',
        link: 'https://httishere666.notion.site/100-e26fd3e7de334d598c657963535f0fea?pvs=4',
        content: '',
      },
      {
        title: 'FlowUs版',
        price: 0,
        remark: '',
        link: 'https://flowus.cn/httishere/share/432b69e1-84d7-4b95-b462-306b7415b84e?code=YJDF4B',
        content: '',
      },
      {
        title: '文字版',
        price: 0,
        remark: '',
        link: '',
        content:
          '带爸妈去旅游 - 黄山<br></br>换一个喜欢的壁纸<br></br>主动给爸妈打电话<br></br>为自己准备生日礼物<br></br>和久未联系的朋友聊天<br></br>给面部做深层清洁护理<br></br>体验网球课<br></br>一个人去打卡网红店<br></br>挑战一天不看短视频（抖音&小红书）<br></br>和朋友去一次清吧喝酒<br></br>体验一天开心消费<br></br>一个人去周边城市走一走<br></br>读一本人物传记<br></br>规划自己的社交账号<br></br>听音乐放空自己<br></br>去公园呼吸新鲜空气<br></br>上一节舞蹈体验课挖掘兴趣<br></br>买一个房间装饰摆件<br></br>去看高校的公开课<br></br>更新作品集<br></br>每周更换床上用品<br></br>摘抄一页文字<br></br>30分钟空腹有氧/周<br></br>尝试户外运动（跑步/跳绳/徒步）<br></br>体验一次露营<br></br>更新个人简历<br></br>去一次游乐园<br></br>练字<br></br>为朋友准备礼物<br></br>和朋友去西湖泛舟<br></br>学习做咖啡<br></br>爬山呼吸新鲜空气<br></br>和朋友去看一场沉浸式话剧<br></br>囤一堆快递然后一起拆<br></br>看一些科普文章视频<br></br>尝试做夸张的美甲<br></br>多吃水果补充维c<br></br>每周睡前泡脚3次<br></br>看满天繁星<br></br>换手机壳/平板壳<br></br>体验一次写真拍摄<br></br>和朋友一起去赏秋<br></br>买一束花送给自己<br></br>读一本感兴趣的书<br></br>冥想30min<br></br>整理衣柜<br></br>换一个发型调整心情<br></br>逛逛书店<br></br>早起听播客<br></br>随机坐公交车漫游<br></br>和朋友去打羽毛球<br></br>写下自己10个优点/3个闪光瞬间<br></br>看TED练习英语<br></br>学习历史<br></br>去公园和阿姨们一起跳广场舞<br></br>在晴天享受下午茶<br></br>定位洗牙<br></br>做一次马杀鸡<br></br>写情绪日记<br></br>玩密室逃脱<br></br>用一个下午追完一部剧<br></br>买一张彩票每天刮一个<br></br>定存5w<br></br>尝试拳击<br></br>换一套新餐具/床上四件套<br></br>学习沟通技巧<br></br>坚持睡前涂身体乳<br></br>爬楼梯去公司（10楼）5次<br></br>看有意思的综艺<br></br>自己开车出去玩<br></br>练习一首外语歌<br></br>周末睡到自然醒<br></br>拍vlog<br></br>和朋友去搓澡<br></br>每周每月复盘总结<br></br>去公园跟跳广场舞<br></br>做甜点烘焙<br></br>自制美味小甜水<br></br>体验一次高空项目<br></br>布置自己的书桌<br></br>多看播客/TED<br></br>看2本关于心理的书<br></br>体验一次采耳<br></br>定期手帐记录<br></br>一个人去看演唱会<br></br>字体练习<br></br>学习一些成语<br></br>拓展一个增加30%收入的副业<br></br>一个人去KTV<br></br>看9.0以上的电影<br></br>看一次日落<br></br>去撸小猫咪<br></br>做一个饮品记录<br></br>整理手机相册<br></br>完成一幅拼图<br></br>学习一些心理学知识<br></br>做一道有难度的菜<br></br>和朋友一起打麻将<br></br>手工DIY<br></br>玩一次桌游',
      },
    ],
    pay_link: '',
    activity: '',
    created: '1725345600000',
    rlink: '',
    hide: true,
  },
  {
    id: 79,
    direction: 'col',
    title: '🔍 用PARA打造自己的笔记系统｜快速整理文档',
    description:
      'PARA（Project，Area，Resource，Archive）是Tiago Forte在《打造第二大脑》里提出的一个方法，它灵活，简单能够有效地管理你自己的各种知识或者信息。',
    detail:
      '最近新学了一个PARA系统来进行个人学习的自我管理，在使用过程中觉得还是挺有趣和有用的，所以这里和大家分享一下我用FlowUs搭建的PARA学习系统。<br>首先PARA（Project，Area，Resource，Archive）是Tiago Forte在《打造第二大脑》里提出的一个方法，它灵活，简单能够有效地管理你自己的各种知识或者信息。<br>P（Project/项目）：是指具有明确的目标以及时间范围的一系列任务，比如完成一个视频课程，阅读一本书，且每个任务可以对应一个领域。<br>A（Area/领域）：日常需要持续一段时间来精进的领域，比如专业技术升级，语言学习等。<br>R（Resource/资源）：持续感兴趣的话题或主题，可以是支持Project和Area的外部知识资源，比如专业课程，文章，书籍等。<br>A（Archive/归档）：已完成或非活动的项目，以及不再维护的Project和Area。<br>所以在使用这个个人管理体系的时候首先需要确定自己的领域（即自己想做的事情的范围），一旦确定了自己的领域那么接下去的项目清单就只要根据你想做的进行就可以。<br>所以我使用PARA建立了我日常的学习体系，在FlowUs内通过多维表可以非常方便我去收集，记录和整理自己的知识，可以将项目，学习日记，领域等等进行管理，可以快速定位查询相关知识储备。<br>在资源内可以通过快捷输入学习数据来自动化计算学习进度，在项目内也会自动汇总关联的资源进度。',
    cover: './assets/templates/PARA/1.png',
    keywords: ['知识整理'],
    link: 'https://flowus.cn/httishere/share/488b5a73-ce00-47ee-a407-727cdc3116d1?code=YJDF4B',
    code: 'njwek',
    flowus: true,
    images: [
      './assets/templates/PARA/2.png',
      './assets/templates/PARA/3.png',
      './assets/templates/PARA/4.png',
      './assets/templates/PARA/5.png',
      './assets/templates/PARA/6.png',
      './assets/templates/PARA/7.png',
      './assets/templates/PARA/8.png',
      './assets/templates/PARA/9.png',
    ],
    rlink: '',
  },
  {
    id: 78,
    direction: 'col',
    title: '👗 整理星人必备｜用Notion打造自己的个人电子衣橱',
    full_title: '',
    description: '',
    detail:
      'Hello，大家好，这里是阿汪同学。<br>最近杭州在立秋之后还是在经历35度以上的高温生活，每天穿什么都成了前一天晚上最重要的事，但是有时候总是记不得自己有些什么衣服，所以导致一些被自己忘记的衣服就成了压箱底再也没穿过。<br>所以我就想给自己建立一个一目了然的电子衣橱用来管理自己当前的所有衣服，也方便我们进行断舍离。<br>这个电子衣橱看板通过管理我们拥有的每个类别的所有内容，帮助我们进行更有意识的购买，避免一些重复购买导致浪费，它可以帮助我们：<br>✨ 可视化所有衣物并进行搭配和清理<br>✨ 计划日常穿搭 & 计划旅行服装<br>✨ 利用购物计划养成延迟满足的习惯<br>PS：在手机相册或者备忘录可以一键生成抠图上传到我们的小衣橱～',
    pay: 4.5,
    off: 4.5,
    off_date: '2024/08/31 00:00:00',
    cover: './assets/templates/wardrobe.png',
    keywords: ['物品管理', '生活管理'],
    video: '',
    m_pay_link: 'https://m.tb.cn/h.gNQsXXLc3nyIq5v?tk=NzyD34zZDWl',
    images: [
      './assets/templates/wardrobe/2.png',
      './assets/templates/wardrobe/3.png',
      './assets/templates/wardrobe/4.png',
      './assets/templates/wardrobe/5.png',
      './assets/templates/wardrobe/6.png',
    ],
    pay_link: '',
    activity: '',
    created: '1724225100000',
    rlink: 'https://httishere666.notion.site/Notion-OOTD-2997f8b46f774819a7a55e2772fcffa8?pvs=4',
  },
  {
    id: 77,
    direction: 'row',
    title: '🔥 开挂！用积分管理打卡开启无痛自律',
    full_title: '',
    description: '',
    detail:
      '1️⃣ 【尝鲜版】：仅包含基本打卡，积分统计和奖品兑换功能模块<br>2️⃣ 【常规版】：包含快捷打卡，热力打卡，打卡进度等功能模块，不支持单日单项多次打卡，每日打卡记录看板，奖品重复兑换（兑换后需重新创建奖品），积分任务功能模块（购买用户可在3个月内通过补差升级）。<br>3️⃣ 【Pro版】：包含视频和图文内介绍的全部功能',
    code: '',
    pay: 12.9,
    off: 0,
    off_date: '',
    cover: './assets/templates/score3.0.jpg',
    keywords: ['自动化数据总结', '个人自律', '习惯打卡'],
    video: '',
    m_pay_link: 'https://m.tb.cn/h.gPup9DlYq26LQu0?tk=AgWx3eMOPEe',
    has_specs: true,
    specs: [
      { title: '尝鲜版', price: 0, remark: '', link: 'https://httishere666.notion.site/2-0-0d5d336cb8af4bb988c1c1303c36b639?pvs=4' },
      { title: '常规版', price: 12.9, remark: '' },
      { title: 'PRO版', price: 17.9, remark: '' },
    ],
    images: [
      './assets/templates/score3/2.png',
      './assets/templates/score3/3.png',
      './assets/templates/score3/4.png',
      './assets/templates/score3/5.png',
      './assets/templates/score3/6.png',
      './assets/templates/score3/7.png',
      './assets/templates/score3/8.png',
      './assets/templates/score3/9.png',
    ],
    pay_link: '',
    activity: 'Pro版可好评送模版',
    created: '1723529580000',
    rlink: 'https://httishere666.notion.site/2-0-0d5d336cb8af4bb988c1c1303c36b639?pvs=4',
  },
  {
    id: 75,
    direction: 'col',
    title: '假如从8月开始自律',
    full_title: '',
    description: '',
    detail: '',
    pay: 4.5,
    off: 4.5,
    off_date: '2024/08/03 00:00:00',
    cover: './assets/templates/August.jpg',
    keywords: ['目标管理', '个人自律', '月度计划'],
    video: '',
    m_pay_link: 'https://m.tb.cn/h.g9YYcEnhGoWQuHB?tk=YRqG32qiujk',
    images: [
      './assets/templates/August/1.png',
      './assets/templates/August/2.png',
      './assets/templates/August/3.png',
      './assets/templates/August/4.png',
      './assets/templates/August/5.png',
      './assets/templates/August/6.png',
    ],
    pay_link: '',
    activity: '',
    created: '1722313860000',
    rlink: 'https://httishere666.notion.site/8-26ec0219a71c4e7788ae99c94ec45209?pvs=4',
  },
  {
    id: 74,
    direction: 'col',
    title: '❤️ 陪伴最大｜FlowUs打造专属自己和宝贝的亲子空间',
    full_title: '',
    description: '',
    detail: '',
    code: '',
    pay: 2.5,
    off: 2.5,
    off_date: '2024/08/11 00:00:00',
    cover: './assets/templates/flowus-family.png',
    keywords: ['家庭生活'],
    video: '',
    m_pay_link: 'https://flowus.cn/httishere/share/2673cc65-2ada-4edc-b5ac-2859e1669dd5?code=YJDF4B',
    images: [
      './assets/templates/flowus-family/2.png',
      './assets/templates/flowus-family/3.png',
      './assets/templates/flowus-family/4.png',
      './assets/templates/flowus-family/5.png',
      './assets/templates/flowus-family/6.png',
      './assets/templates/flowus-family/7.png',
    ],
    pay_link: '',
    activity: '',
    created: '1721957340000',
    flowus: true,
    rlink: 'https://flowus.cn/httishere/share/2673cc65-2ada-4edc-b5ac-2859e1669dd5?code=YJDF4B',
  },
  {
    id: 73,
    direction: 'col',
    title: '🍎 用苹果指令丝滑记账到Notion',
    full_title: '',
    description: '',
    detail: '❗️ 已购买过记账模版的小伙伴可通过下单平台联系客服领取快捷指令～',
    code: '',
    pay: 9.9,
    off: 0,
    off_date: '',
    cover: './assets/templates/ios-shortcut2.JPG',
    keywords: ['记账', 'iOS快捷指令'],
    video: '//player.bilibili.com/player.html?isOutside=true&aid=1106128238&bvid=BV1Pw4m1Y7yT&cid=1614217541&p=1',
    m_pay_link: 'https://m.tb.cn/h.giOFufzlpHReztT?tk=8hCz3Y5NLwv',
    has_specs: true,
    specs: [
      { title: '适配于记账1.0&2.0', price: 9.9, remark: '' },
      { title: '适配于记账3.0', price: 9.9, remark: '' },
    ],
    pay_link: '',
    created: '1720873020000',
  },
  {
    id: 72,
    direction: 'col',
    title: 'Notion 记账 + ios快捷指令（一）',
    description: '',
    cover: './assets/templates/iOS-jz1.JPG',
    keywords: ['记账', 'iOS快捷指令'],
    link: 'https://httishere666.notion.site/Notion-IOS-74d52c08018749c08768d228230bf9c3?pvs=4',
    code: 'ias87',
    flowus: false,
    rlink: '',
  },
  {
    id: 71,
    direction: 'row',
    title: 'I人的人际关系管理体系',
    full_title: '❤️ 本i人的人际关系管理体系 · 轻松有效突破社交困境',
    description: '轻松有效突破社交困境',
    detail:
      '之前和大家分享的很多模版都是和学习计划以及笔记相关的，也有小伙伴希望我分享几个生活管理类的模版，今天和大家分享一下用Notion做人际管理。<br>你是否陷入过社交困境，是不是经常约朋友吃饭却不太记得TA的口味，也想朋友往来礼物有个清单记录，日常想要给朋友一个生日惊喜又怕自己记不住，这个模版可以帮助你建立和维护所有人际关系，是你的人脉管理也是你和朋友的回忆录！',
    code: '',
    pay: 3.5,
    off: 0,
    off_date: '',
    cover: './assets/templates/temp-renji.jpeg',
    keywords: ['人际关系', '生活管理'],
    video: '//player.bilibili.com/player.html?aid=366596462&bvid=BV1J94y1E73t&cid=1347824463&p=1',
    m_pay_link: 'https://m.tb.cn/h.gi20CezEUcQhSb2?tk=1RiO3bw76t7',
    pay_link: '',
    created: '1720747860000',
  },
  {
    id: 70,
    direction: 'row',
    title: '❤️ 时间看得见！',
    full_title: '❤️ 时间看得见！用Notion让你的时间更加具像化',
    description: '',
    detail: '',
    pay: 0,
    off: 0,
    off_date: '',
    cover: './assets/templates/2024-notion-calendar.png',
    keywords: ['时间管理', '待办管理'],
    video: '//player.bilibili.com/player.html?bvid=BV1e4421X78y&page=1',
    m_pay_link: '',
    pay_link: '',
    created: '1717642440000',
    link: 'https://httishere666.notion.site/Todos-with-Notion-Calendar-09f15cb63f6b436094daa760f009c0cc?pvs=4',
  },
  {
    id: 69,
    direction: 'col',
    title: '😁 J人狂喜｜这个年月周联动计划也太好用了！',
    description:
      '对于这个执行任务的完成情况会自动逐级进行汇总的计划阿汪很早之前就在计划如何能更好的实现以及减少操作成本。<br><br>本计划主要分成了：<br><br>🎯 计划维度看板：可以重点关注自己的一些维度目标。<br><br>🎯 计划执行看板： 可以直观的看到自己当前所有目标计划的完成情况以及进度。<br><br>🎯 计划拆分清单： 在这里你可以对自己的大目标进行向下拆分，如年度计划可拆分为月计划或者目标分配，这样通过细化目标能提高我们的执行力。<br><br>🎯 计划OKR管理： 在可以可以通过设定KR值来进行KR进度管理。',
    cover: './assets/templates/y-m-w/1.png',
    keywords: ['年月周', '计划联动'],
    link: '',
    code: '',
    flowus: false,
    rlink: 'https://httishere666.notion.site/70f42d8db1714d058dc1ddbf67bdfd2f?pvs=4',
  },
  {
    id: 68.1,
    direction: 'col',
    title: '这个可视化周计划复盘太酷啦！',
    description: '',
    cover: './assets/templates/2024weekly/Notion.jpg',
    keywords: ['个人管理', '复盘记录', '周复盘', '每周计划'],
    link: 'https://httishere666.notion.site/Weekly-defcecd8f51b4b71a1a001d819f9cb2e?pvs=4',
    code: '',
    flowus: false,
    rlink: 'https://httishere666.notion.site/Weekly-80362a9279b14e8eaba82fb3289f0203?pvs=4',
    hide: true,
  },
  {
    id: 68,
    direction: 'col',
    title: '🆘 这个可视化周计划复盘太酷啦！',
    full_title: '🆘 救命！帮我无痛提高执行力｜这个Notion可视化周复盘也太酷啦！',
    description: '',
    detail:
      '✅ 周复盘体系主要分成了待办，每日打卡，积分打卡，专注计时等板块。<br>通过高度的可视化可以帮助我们更好地提高执行力！<br>和阿汪一起🆙🆙吧！',
    code: '',
    pay: 6.8,
    off: 0,
    off_date: '',
    cover: './assets/templates/2024weekly/1.png',
    keywords: ['个人管理', '复盘记录', '周复盘', '每周计划'],
    video: '//player.bilibili.com/player.html?aid=1104216424&bvid=BV1Qw4m1X7qy&cid=1534167512&p=1',
    m_pay_link: 'https://m.tb.cn/h.g1O8eV4HSj6VqLs?tk=HBZDWtoTPep',
    has_specs: true,
    specs: [
      {
        title: '试用版',
        price: 0,
        remark: '不支持积分打卡，时间管理以及可视化日程时间轴',
        link: 'https://httishere666.notion.site/Weekly-defcecd8f51b4b71a1a001d819f9cb2e?pvs=4',
      },
      { title: '常规版', price: 6.8, remark: '不支持时间管理和可视化日程时间轴' },
      { title: 'Pro版', price: 9.9, remark: '支持视频内全部功能' },
    ],
    images: [
      './assets/templates/2024weekly/2.png',
      './assets/templates/2024weekly/3.png',
      './assets/templates/2024weekly/4.png',
      './assets/templates/2024weekly/5.png',
      './assets/templates/2024weekly/6.png',
      './assets/templates/2024weekly/7.png',
      './assets/templates/2024weekly/8.png',
    ],
    pay_link: '',
    created: '1715043720000',
    activity: 'Pro版可好评送模版',
  },
  {
    id: 56,
    direction: 'col',
    title: '❗️ 用一年改变自己 → 热辣滚烫版减肥计划',
    description: 'You only live once.',
    cover: './assets/templates/temp-2024-loss.jpg',
    keywords: ['个人管理', '健康'],
    link: 'https://httishere666.notion.site/985b8c121e9044eb8c7d73bebd5f5a43?pvs=4',
    pay: 9.9,
    rlink: 'https://httishere666.notion.site/985b8c121e9044eb8c7d73bebd5f5a43?pvs=4',
    hide: false,
    images: [
      './assets/templates/2024-weight/3.png',
      './assets/templates/2024-weight/4.png',
      './assets/templates/2024-weight/5.png',
      './assets/templates/2024-weight/6.png',
      './assets/templates/2024-weight/7.png',
      './assets/templates/2024-weight/8.png',
    ],
  },
  {
    id: 67.1,
    direction: 'col',
    title: '✈️ J人必备旅行计划',
    cover: './assets/templates/2024travel/1.png',
    link: 'https://httishere666.notion.site/0501-City-Walk-42657b759eba42c28aba251bd6d2b901?pvs=4',
    hide: true,
  },
  {
    id: 67,
    direction: 'col',
    title: '✈️ J人必备旅行计划',
    full_title: '✈️ J人必备旅行计划',
    description: '',
    detail:
      '去年和大家分享了一下我的旅行计划模板，马上五一就要来啦！！！你们有计划去哪玩嘛？买好机票车票了吗？小时候看电视里的港剧就一直对香港充满了向往，这次终于有机会可以和朋友一起去玩啦！<br><br>作为一个超级j人在旅行前我一定会制定和记录好详细的行程计划，而且也可以在路程过程中方便查看，所以今天和大家分享一下我用FlowUs搭建的五一港澳旅行计划。<br><br>在这个上面可以通过待办列表，多维看板，嵌入书签等形式展示特定的内容，可以充分直观查看和记录各类信息。',
    code: '',
    pay: 4.5,
    off: 0,
    off_date: '',
    cover: './assets/templates/2024travel/1.png',
    keywords: ['生活管理', '旅行计划'],
    video: '',
    m_pay_link: 'https://m.tb.cn/h.gbvZfBmdb1TOTBx?tk=OBSvWsBvXhP',
    images: [
      './assets/templates/2024travel/2.png',
      './assets/templates/2024travel/3.png',
      './assets/templates/2024travel/4.png',
      './assets/templates/2024travel/5.png',
      './assets/templates/2024travel/6.png',
    ],
    pay_link: '',
    created: '1714371000000',
  },
  {
    id: 66.1,
    direction: 'col',
    title: '🎨 智能可视化日记本',
    cover: './assets/templates/memo/memo.png',
    link: 'https://httishere666.notion.site/Daily-e764d614e1e547d891ecc5da9f179619?pvs=4',
    hide: true,
    created: '1714014240000',
  },
  {
    id: 66,
    direction: 'col',
    title: '🎨 智能可视化日记本',
    full_title: '🎨 智能可视化日记本｜这么记日记爽麻了',
    description: '在该模板可以看到自己日记的整体情况，如记录数，字数等等，从有趣的可视化帮助我们提高记录兴趣和效率。',
    detail:
      '此 Notion 模板可帮助您简化笔记过程，使您的笔记不仅井井有条，而且易于检索。<br>⤵️ 灵感小记：即时记下想法<br>⤵️ 日记看板：在这里可以看到自己所有的日记复盘内容<br>⤵️ 主题标签：将日记笔记等可以标记为相关主题和标签，以帮助我们更有效地组织它们<br>⤵️ 那年今日：会自动展示过去几年当前日期的记录内容<br>⤵️ 可视化汇总看板：在该看板可以看到自己日记的整体情况，如记录数，字数等等，从有趣的可视化帮助我们提高记录兴趣和效率。<br>这个日记复盘板块可以帮助保持井井有条，告别分散的信息，非常适合任何专注于学习和自我提升的小伙伴。',
    code: '',
    pay: 3.5,
    off: 0,
    off_date: '',
    cover: './assets/templates/memo/memo.png',
    keywords: ['复盘记录', '自我剖析'],
    video: '//player.bilibili.com/player.html?aid=1853683141&bvid=BV1Gp421S74g&cid=1519376013&p=1',
    m_pay_link: 'https://m.tb.cn/h.gYsdD07RElgqQFT?tk=jshuWsIhYLD',
    images: [
      './assets/templates/memo/2.png',
      './assets/templates/memo/3.png',
      './assets/templates/memo/4.png',
      './assets/templates/memo/5.png',
    ],
    pay_link: '',
    created: '1714014240000',
  },
  {
    id: 64.1,
    direction: 'col',
    title: '❤️ 做自己情绪的主人',
    cover: './assets/templates/mood/1.jpg',
    hide: true,
    rlink: 'https://httishere666.notion.site/bab3888fc44f4319b439fe139ab469d2?pvs=4',
  },
  {
    id: 64,
    direction: 'col',
    title: '❤️ 做自己情绪的主人',
    full_title: '❤️ 做情绪的主人｜接纳自己的每一种情绪',
    description: '',
    detail:
      '今天分享的这个是一个可以帮助我们以有趣且直观的方式跟踪自己的情绪，还能根据自己的喜好对其进行个性化设置。<br>☀️ 月度看板·年度看板：在这里可以直观的看到我们所有情绪记录的汇总数据，并以高度可视化的形式进行展示。<br>😄 情绪/能量记录：提供了充足的空间来每天记录，可以帮助我们深入了解自己的情绪模式。',
    pay: 0,
    off: 0,
    off_date: '',
    cover: './assets/templates/mood/mood-0.jpg',
    keywords: ['个人管理'],
    video: '',
    m_pay_link: 'https://m.tb.cn/h.g0Yy8VuQPckcsgE?tk=iugkWrX5GRa',
    has_specs: true,
    specs: [{ title: '情绪管理 · PRO版', price: 2.8 }],
    images: [
      './assets/templates/mood/1.jpg',
      './assets/templates/mood/2.jpg',
      './assets/templates/mood/3.jpg',
      './assets/templates/mood/4.jpg',
      './assets/templates/mood/5.jpg',
      './assets/templates/mood/6.jpg',
      './assets/templates/mood/7.jpg',
    ],
    pay_link: '',
    rlink: 'https://httishere666.notion.site/bab3888fc44f4319b439fe139ab469d2?pvs=4',
  },
  {
    id: 63,
    direction: 'col',
    title: '📁 2023模板合集｜32个模板直接打包带走',
    full_title: '',
    description: '',
    detail: '',
    code: '',
    pay: 115,
    off: 46,
    off_date: '',
    cover: './assets/templates/2023-all.png',
    keywords: ['个人管理', '生活管理', '工作管理'],
    video: '',
    m_pay_link: 'https://m.tb.cn/h.ganqAC4HPVqLhlI?tk=Gti2Wqptmc7',
    images: ['./assets/templates/2023-all/2.png'],
    pay_link: '',
  },
  {
    id: 62,
    direction: 'col',
    title: '终极人生管理系统 - 从记录开始',
    description:
      '作为一个超级J人，从上学开始就非常喜欢写手帐本来管理自己生活的方方法面面，后来接触了笔记软件之后也用过很多，但是每次使用记录的时候总是要打开一个又一个的app，计划类的，日记类的，打卡类的，所以特别想搭建一个日常可以使用的all in one的个人系统。<br><br>然后在过去1年多的时间内我和大家分享了很多很多模板，有小伙伴说很好用，也有小伙伴觉得上手有点难，确实我个人在使用过程中会需要使用到很多的数据所以模板的使用操作就会相对繁琐，这也是我一直以来忽略的事，所以今天就和大家分享一下新手小伙伴也能直接入手的FlowUs「终极人生管理体系」。<br><br>📅 月周日计划：在这里我把待办事项分成了月周日三个模板，在日计划内可以规划记录我们今日的所有日程，在周计划内可以记录自己各方面需要完成的事，月计划可以详细记录自己的一些重点事项作为复盘。<br><br>🎯 目标里程碑：将个人目标分成不同类型进行进度管理，利用不同的关键结果对项目进行拆解完成。<br><br>🖊️ 提醒&日记：可以在今日提醒模块添加提醒事项并通过设置提醒时间进行自动化提醒（会通过推送的形式），在每日日记模块分成了「碎碎念」，「我真棒」，「下次一定」，「好事发生」等板块，可以在看板和日历上直观的看到自己的所有日记灵感。<br><br>📖 阅读观影：可以对自己的阅读，观影，电视剧等记录进行管理，可以评分和观后感记录。<br><br>📑 学习计划：对正在学习的内容进行输入输出的管理，可以记录自己的输出笔记等。<br><br>🥗 生活管理：包含运动记录，饮食记录，护肤记录，渗透自己生活的方法面面。<br><br>当然，工具只是辅助作用，要想管理好自己还是需要付出时间和精力养成一个良好的记录习惯，无论你是用纸笔还是软件，希望大家都可以找到自己最适合的方式和我一起记录吧。<br><br>',
    cover: './assets/templates/flowus-2024OS.jpg',
    keywords: ['个人管理', '复盘记录'],
    link: 'flowus-2024OS.jpg',
    flowus: true,
    images: [
      './assets/templates/flowus-2024OS/2.png',
      './assets/templates/flowus-2024OS/3.png',
      './assets/templates/flowus-2024OS/4.png',
      './assets/templates/flowus-2024OS/5.png',
      './assets/templates/flowus-2024OS/6.png',
      './assets/templates/flowus-2024OS/7.png',
      './assets/templates/flowus-2024OS/8.png',
      './assets/templates/flowus-2024OS/9.png',
    ],
    rlink: '',
  },
  {
    id: 65,
    direction: 'col',
    title: '月复盘｜努力会被看到，一起准备月计划',
    description:
      '♦️ 本月To do 和 Not to do<br>♦️ 阅读/观影记录：记录自己本月的阅读情况，我最近喜欢上了看TED演讲，有点上头<br>♦️ 每周复盘：每周记录一下特定的事件和图片<br>♦️ 日常事项：可以根据时间维度进行事项分类，可以分享整月事项和周事项，设定目标数据进行进度更新，设置好日程事项后在顶部回显示未来3天的事项提醒<br>♦️ 每周打卡：同样的根据时间维度分成了每周打卡，在打卡最后可以更新本周的打卡进度<br>♦️ 月末复盘：使用KISS法进行复盘',
    cover: './assets/templates/flowus-2023month.jpg',
    keywords: ['月度计划', '复盘', '效率提升'],
    link: 'https://flowus.cn/httishere/share/e1d8cabf-8be0-4167-8897-394b561bbb10?promotionChannel=Red_fwj_09',
    code: '',
    flowus: true,
    rlink: '',
  },
  {
    id: 61,
    direction: 'row',
    title: '行之所往 · 旅行计划',
    description:
      '🌸 行李清单<br>在这里我我先列了部分必需品，便于在出发前再进行确认，防止遗漏物品<br>🌸 行前准备<br>我标记了几个比较重要的准备事件，比如订车票，订住宿等等，使用「待办事项」方便确认准备是否完全<br>🌸 行程计划<br>我根据日期将其分成了5块，这样每天的行程就会非常清晰，还可以规划每天具体的交通路线，景点等，还可以记录美食打卡！',
    cover: './assets/templates/flowus-2023-51.jpg',
    keywords: ['生活关联', '旅行计划'],
    link: 'https://flowus.cn/httishere/share/1d3ebfcf-2256-4cdd-b8f4-e4178fdb70a8?promotionChannel=Red_fwj_24',
    code: '',
    flowus: true,
    rlink: '',
  },
  {
    id: 60,
    direction: 'col',
    title: '用多维表这样管理周计划太香了',
    description:
      '多维表其实就是一个数据库，包含了多条数据记录，每条数据都有对应的属性，根据属性可以表现多种视图，有日期属性可以创建日历视图，有单选属性可以创建看板视图等等。<br>在多维表内可以方便的统计各类数据，也可以利用公式添加多种逻辑判断，以及更高阶的关联汇总用法。<br>🍃 🍃 本周目标<br>在该表格可设置自己的周目标以及目标标签，可选择具体任务事件，以及根据任务完成情况展示进度条，在本表格可以自定义进度条的emoji，让你的进度条更可爱～<br><br>🍃 🍃 本周打卡<br>必不可少的习惯打卡，这个模块是使用列表（目录）视图，我已经初始化了5个打卡项目，根据具体打卡情况会显示相应的打卡进度和打卡状态，如果需要删除或者添加打卡项目请看图上详细说明～<br><br>🍃 🍃 本周日程<br>记录本周的所有待办以及完成情况，每个待办都可选择「重要且紧急」，「重要不紧急」，「紧急不重要」，「不重要不紧急」四种象限，让你的待办变得更清晰。',
    cover: './assets/templates/flowus-2023-week.JPG',
    keywords: ['复盘', '效率提升'],
    link: 'https://flowus.cn/httishere/share/e6bfbf77-d6cd-4031-b564-cd0a86c6f2f4?promotionChannel=Red_fwj_07',
    code: '',
    flowus: true,
    images: [
      './assets/templates/flowus-2023-week/1.png',
      './assets/templates/flowus-2023-week/2.png',
      './assets/templates/flowus-2023-week/3.png',
      './assets/templates/flowus-2023-week/4.png',
      './assets/templates/flowus-2023-week/5.png',
    ],
    rlink: '',
  },
  {
    id: 59,
    direction: 'col',
    title: '超好用的假期逆袭计划 · 竖版时间轴可视化日程管理',
    description: '对我来说【可视化】的数据和内容会更让我有完成的动力，相信自己一定可以！让我们一起在假期完成逆袭吧！',
    cover: './assets/templates/flowus-2023jiaqi.jpg',
    keywords: ['个人管理', '个人自律', '效率提升'],
    link: 'https://flowus.cn/httishere/share/3d57c448-8dfb-4dd6-97a7-7329484f3185?promotionChannel=Red_fwj_17',
    code: '',
    flowus: true,
    images: [
      './assets/templates/flowus-2023jiaqi/1.png',
      './assets/templates/flowus-2023jiaqi/2.png',
      './assets/templates/flowus-2023jiaqi/3.png',
      './assets/templates/flowus-2023jiaqi/4.png',
    ],
    rlink: '',
  },
  {
    id: 58,
    direction: 'col',
    title: 'FlowUs 运动减肥计划 · 体重曲线',
    description: '🥳 设计亮点：体重曲线｜功能丰富｜操作较简单',
    cover: './assets/templates/flowus-2023weight.jpeg',
    keywords: ['健康', '个人自律'],
    link: 'https://flowus.cn/httishere/share/b8f074fa-86c0-4abf-9416-6f92201a5325?promotionChannel=Red_fwj_18',
    code: '',
    flowus: true,
    rlink: '',
  },
  {
    id: 57.1,
    direction: 'col',
    title: '🧠 建立个人知识库 ',
    full_title: '🧠 建立个人知识库 · 保持高效碎片化整理【我的第二大脑】',
    description: '超强大的双向关联',
    detail: '',
    code: '',
    off_date: '2024/04/30 23:59:00',
    cover: './assets/templates/brain/row-2.png',
    keywords: ['自动化数据总结', '效率提升', '知识整理'],
    video: '',
    hide: true,
    link: 'https://httishere666.notion.site/All-in-one-9410d789d572481e8a968a6b18c080b3?pvs=4',
  },
  {
    id: 57,
    direction: 'col',
    title: '🧠 建立个人知识库 ',
    full_title: '🧠 建立个人知识库 · 保持高效碎片化整理【我的第二大脑】',
    description: '超强大的双向关联',
    detail: '',
    code: '',
    pay: 39.9,
    off: 10,
    off_date: '2024/04/30 23:59:00',
    cover: './assets/templates/temp-brain.png',
    keywords: ['自动化数据总结', '效率提升', '知识整理'],
    video: '',
    m_pay_link: 'https://m.tb.cn/h.5CSVe4D28E7rJuJ?tk=now7WLVGeEE',
    images: [
      './assets/templates/brain/3.png',
      './assets/templates/brain/4.png',
      './assets/templates/brain/5.png',
      './assets/templates/brain/7.png',
      './assets/templates/brain/8.png',
      './assets/templates/brain/9.png',
      './assets/templates/brain/10.png',
    ],
    pay_link: '',
    activity: '好评送模版',
  },
  {
    id: 55,
    direction: 'col',
    title: '🌕 月度复盘2.0',
    full_title: '🌕 月度复盘2.0｜原来一个月可以做这么多事【教程视频待更新】',
    description: '重建自己的生活秩序感',
    detail: '',
    code: '',
    pay: 19.9,
    cover: './assets/templates/temp-month-v2.png',
    keywords: ['月度复盘', '自动化数据总结'],
    video: '',
    m_pay_link: 'https://m.tb.cn/h.5FVh4KQVx8WFAKt?tk=staqWl63t6R',
    pay_link: '',
    images: [
      './assets/templates/monthly-2.0/1.png',
      './assets/templates/monthly-2.0/2.png',
      './assets/templates/monthly-2.0/3.png',
      './assets/templates/monthly-2.0/4.png',
      './assets/templates/monthly-2.0/5.png',
      './assets/templates/monthly-2.0/6.png',
      './assets/templates/monthly-2.0/7.png',
    ],
    activity: '好评送模版',
  },
  {
    id: 54,
    direction: 'row',
    title: '👑 【FlowUs】阿汪同学全部模板订阅',
    full_title: '👑 【FlowUs】阿汪同学全部模板订阅｜更新即直接推送',
    description: '',
    detail: '<br>✅ 全部FlowUs模版（含后续更新，更新自动推送）<br>✅ 限时分享组件<br>✅ 模版定制服务享受9折优惠',
    code: '',
    pay: 99,
    cover: './assets/templates/temp-flowus.png',
    keywords: ['永久会员', '更新推送'],
    video: '',
    m_pay_link: '',
    pay_link: 'https://flowus.cn/httishere/share/fdfe7d91-e11f-499e-aff7-3232691d6e8b?promotionChannel=Red_fwj_44',
    top: true,
  },
  {
    id: 53,
    direction: 'col',
    title: '😄 打卡还能这么玩！',
    full_title: '😄 打卡还能这么玩！用Notion建立自己的打卡热力图吧！',
    description: 'Database表内按钮快捷打卡｜自动统计月度热力',
    detail:
      '前段时间Notion更新了Database表内按钮功能，我也和大家分享了一下它的基本用法，然后也说会和大家分享这个按钮在打卡上的应用，所以今天是这个打卡按钮的分享。<br>✅ 快捷打卡：我们可以通过点击计划上的打卡按钮进行快捷打卡，然后打卡次数和今日打卡状态会自动更新。<br>📊 数据统计：每次打卡之后会自动话进行本周，本月和今年的数据统计，直观了解当前打卡数据。<br>🔥 打卡热力图：每次打卡后也会同步自动话动态更新月度打卡热力，还可以手动切换热力图的月份能够更智能化的了解自己的打卡情况，还可以根据自己的喜好进行颜色的选择。',
    code: '',
    pay: 9.9,
    cover: './assets/templates/temp-heat.png',
    keywords: ['自动化数据总结', '习惯打卡'],
    video: '//player.bilibili.com/player.html?aid=1201006465&bvid=BV1gF4m1j7Nj&cid=1450902433&p=1',
    m_pay_link: 'https://m.tb.cn/h.5uBFtSte1EzpxwZ?tk=r2QpWl134qJ',
    pay_link: '',
  },
  {
    id: 52,
    direction: 'row',
    title: '📊 PARA轻松构建第二大脑',
    full_title: '📊 Notion x PARA搭建你的人生知识管理数字系统｜轻松构建第二大脑',
    description: '',
    detail:
      '本模板是基于Notion的个人知识和职业发展管理模板，包括项目、领域、资源和归档等四个方面，可以方便地规划日常任务、管理项目进度和资源，以及归档不再关注的内容。</br>同时，提供了重要提醒和任务提醒的功能，帮助我们更好地跟进任务和复盘。',
    pay: 3.8,
    cover: './assets/templates/temp-para.png',
    pay_img: '',
    keywords: ['个人管理', '自动化数据总结'],
    video: '//player.bilibili.com/player.html?aid=1950156334&bvid=BV1VC411z7w8&cid=1429643520&p=1',
    m_pay_link: 'https://m.tb.cn/h.5uxy01y7rWvrq9r?tk=iU9uWl0S6X1',
  },
  {
    id: 51,
    direction: 'row',
    title: '💪 开启充满秩序感的2024',
    full_title: '❌ 拒绝躺平摆烂｜你一定需要这份All in one自我管理计划',
    description: '这套模板里面包含了年度计划，年度看板，日常打卡，日程管理，周计划，阅读观影，计划复盘等板块，你们开始2024规划了吗？',
    detail:
      'Hello，大家好，这里是阿汪同学！有好多小伙伴和我一起用年度计划度过了2023，不知道大家完成的如何，反正我感觉因为有了明确具体的目标和复盘方法，整个个人管理的效率真的大大提升，所以2024我也同样和大家分享我的2024年度计划。<br>这个Notion版的2024 All in one模板里面包含了年度计划，年度看板，日常打卡，日程管理，周计划，阅读观影，计划复盘等板块，可以更全面更直观地进行自我管理！',
    code: '',
    pay: 8.9,
    cover: './assets/templates/temp-2024.JPG',
    keywords: ['个人管理', '年度计划'],
    video: '//player.bilibili.com/player.html?aid=964918452&bvid=BV1Rp4y1f7gL&cid=1370301815&p=1',
    m_pay_link: 'https://m.tb.cn/h.5GEqTuQds3STv62?tk=RccwWPQCjWd',
    has_specs: true,
    specs: [
      { title: 'Notion 2024全年计划 · 常规版', price: 8.9 },
      { title: 'Notion 2024全年计划 · PRO版', price: 11.9 },
    ],
    pay_link: '',
  },
  {
    id: 50,
    direction: 'row',
    title: '📊 PARA轻松构建第二大脑',
    full_title: '📊 Notion x PARA搭建你的人生知识管理数字系统｜轻松构建第二大脑',
    description: '',
    detail:
      '本模板是基于Notion的个人知识和职业发展管理模板，包括项目、领域、资源和归档等四个方面，可以方便地规划日常任务、管理项目进度和资源，以及归档不再关注的内容。</br>同时，提供了重要提醒和任务提醒的功能，帮助我们更好地跟进任务和复盘。',
    code: '57sjw',
    pay: 0,
    cover: './assets/templates/temp-para.png',
    pay_img: '',
    keywords: ['个人管理', '自动化数据总结'],
    video: '//player.bilibili.com/player.html?aid=1950156334&bvid=BV1VC411z7w8&cid=1429643520&p=1',
    m_pay_link: '',
    pay_link: '',
    link: 'https://httishere666.notion.site/PARA-21692b94a2004be19859cb0a7bb9a0af?pvs=4',
    hide: true,
  },
  {
    id: 49,
    direction: 'col',
    title: '❌ 寒假不摆烂',
    description: 'Notion新手也能直接上手的寒假计划，这个寒假和我一起卷起来吧！',
    cover: './assets/templates/temp-2024winter.JPG',
    keywords: [],
    link: '/mpicks/get',
    rlink: 'https://httishere666.notion.site/by-4b221446895246f5bc64ec4807a4a76b?pvs=4',
  },
  {
    id: 48,
    direction: 'col',
    title: '🎉 超有成就感的播客笔记',
    description: '随时随地轻松收听和记录',
    cover: './assets/templates/temp-podcast.jpg',
    keywords: ['学习计划', '播客笔记'],
    link: '/mpicks/get/code',
    code: '5762sz',
    rlink: 'https://httishere666.notion.site/a28f3c3706e04e5ca7281f012704e8fd?pvs=4',
  },
  {
    id: 47,
    direction: 'row',
    title: '🔥 外网超火的复盘规划模板',
    description: 'YearCompass带你回顾过去计划新年',
    cover: './assets/templates/temp-2023review.jpeg',
    keywords: ['复盘', '自我剖析'],
    link: '/mpicks/get/code',
    rlink: 'https://httishere666.notion.site/YearCompass-751cee5d9aa24f36a885306c34ca74b7?pvs=4',
  },
  {
    id: 46,
    direction: 'row',
    title: 'I人的人际关系管理体系',
    description: '轻松有效突破社交困境',
    cover: './assets/templates/temp-renji.jpeg',
    keywords: ['人际关系', '生活管理'],
    link: '/mpicks/get/code',
    code: 'e0113d',
    rlink: 'https://httishere666.notion.site/Relationship-Journal-8d610d60dd87460ca06a061295ea0711?pvs=4',
    hide: true,
  },
  {
    id: 45,
    direction: 'row',
    title: '提前布局2024愿景板',
    description: '给2024提前布局结果清单',
    cover: './assets/templates/temp-2024.jpeg',
    keywords: ['年度计划', '目标管理'],
    link: 'https://httishere666.notion.site/2024-8300d65a6a5d4ae9be7524290651aa97?pvs=4',
  },
  {
    id: 44,
    direction: 'row',
    title: '闪卡笔记背书嘎嘎爽',
    full_title: '🐮 真的别太牛｜用Notion做闪卡笔记背书嘎嘎爽！',
    description: '闪卡集合 · 看板 · 学习记录',
    detail:
      '前段时间我不是在备考嘛，就有很多要背要记的知识点，然后那时候就get到了闪卡记忆法，于是就把闪卡用法运用到了我的Notion内，背书直接嘎嘎爽！在这个闪卡空间你也可以轻松管理你所有的知识点，记忆内容，也能轻松复习。',
    pay: 2.5,
    cover: './assets/templates/temp-flashcard.jpeg',
    pay_img: './assets/pay-img/pay-flashcard.png',
    keywords: ['学习计划', '个人自律', '效率提升'],
    video: '//player.bilibili.com/player.html?aid=663756640&bvid=BV15a4y1Z7UV&cid=1342689469&p=1',
    m_pay_link: 'https://m.tb.cn/h.5liPF8T?tk=PsqIW4ZNN8Z',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=751328759741',
  },
  {
    id: 43,
    direction: 'row',
    title: '【2025款】考研时间管理大师',
    full_title: '📒 考研学生党必备｜高效备考 · 考研时间管理大师',
    description: '全程备考计划模板',
    detail:
      '这次把我备考期间的一些设计马不停蹄地做成了这版考研计划模版，会比原先的更细致更容易上手，还增加了闪卡记忆部分，让你的学习更智能化。',
    pay: 6.5,
    cover: './assets/templates/temp-kaoyan.jpeg',
    pay_img: './assets/pay-img/pay-2025kaoyan.png',
    keywords: ['学习计划', '个人自律', '时间管理'],
    video: '//player.bilibili.com/player.html?aid=323571407&bvid=BV16w411H7rY&cid=1336929305&p=1',
    m_pay_link: 'https://m.tb.cn/h.5PexRnJ?tk=Yc3gW4Zlu4m',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=749674328277',
    activity: '好评送模版',
  },
  {
    id: 42,
    direction: 'row',
    title: '工作项目管理模版',
    full_title: '❗️ 打工人必备！直接工作效率翻倍的工作项目管理模版',
    description: '甘特图追踪 · 待办清单',
    detail:
      '之前和大家分享过很多日常生活用到的场景模版，今天分享的是项目管理 · 甘特图追踪的Notion模版，可以让你更直观快速的进行工作项目规划。',
    pay: 3.5,
    cover: './assets/templates/temp-work.jpeg',
    pay_img: './assets/pay-img/pay-work.png',
    keywords: ['工作管理', '效率提升'],
    video: '//player.bilibili.com/player.html?aid=791034650&bvid=BV1sC4y1m7NL&cid=1334977498&p=1',
    m_pay_link: 'https://m.tb.cn/h.5Pewda8?tk=1A5iW4ZPURO',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=750178551141',
  },
  {
    id: 41,
    direction: 'row',
    title: '有趣的可视化睡眠追踪',
    full_title: '❌ 拒绝熬夜｜用Notion有趣的可视化管理自己的睡眠追踪',
    description: '升级版睡眠管理追踪',
    detail:
      'Hello，大家好，这里是阿汪同学！</br>之前我和大家分享过睡眠曲线，睡眠区间这类的模版，然后这段时间我一直在做睡眠追踪，希望可以简单直观的查看自己最近的睡眠状况以及统计数据，想从一定程度上改掉自己熬夜的坏习惯（虽然还没有）。</br>👏 所以我用Notion对我们的睡眠管理追踪进行了升级，这个睡眠追踪模版只要记录每天的入睡和起床时间就会自动计算睡眠时间以及评价，还能自动汇总分析周对比以及月对比。</br>😄 在汇总卡片内还会自动汇总23点前入睡，24点前入睡等天数，提供了一个强大又直观的数据统计。</br>💤 通过每日睡眠时间和睡眠汇总的结合能更加方便我们观测自己每天的睡眠以及能量，也能方便我们能及时调整作息！',
    pay: 3.5,
    cover: './assets/templates/temp-sleep.jpeg',
    pay_img: './assets/pay-img/pay-sleep.png',
    keywords: ['时间管理', '个人自律'],
    video: '//player.bilibili.com/player.html?aid=963249515&bvid=BV16H4y1B7Xm&cid=1325764845&p=1',
    m_pay_link: 'https://m.tb.cn/h.5OeVgy1?tk=kcSmW4ZQXC0',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=748567874500',
  },
  {
    id: 40,
    direction: 'row',
    title: '购物攻略拿捏',
    description: '话费统计 · 活动汇总 · 单价比对',
    cover: './assets/templates/temp-shopping.jpeg',
    keywords: ['购物管理', '生活管理'],
    link: 'https://httishere666.notion.site/Notion-3c8f726cbac847afb5ea2f5a4b8b519f?pvs=4',
  },
  {
    id: 39,
    direction: 'row',
    title: '囤货爱好者的福音',
    full_title: '🛍️ 双十一来临｜这样管理囤货物品也太6了',
    description: '所有囤货库存还有清理过期产品',
    detail:
      '最近刚好在整理家里的所有囤货库存还有清理过期产品，之前也和大家分享过一个护肤美妆管理的模版，正好趁这次整理的机会对它进行了升级，作为全物品管理。',
    pay: 4.5,
    cover: './assets/templates/temp-tunhuo.jpeg',
    pay_img: './assets/pay-img/pay-tunhuo.png',
    keywords: ['物品管理', '生活管理'],
    video: '//player.bilibili.com/player.html?aid=322362369&bvid=BV16w41167NP&cid=1303625617&p=1',
    m_pay_link: 'https://m.tb.cn/h.5PerkJ4?tk=HRD3W4ZSKA7',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=744307823129',
  },
  {
    id: 38,
    direction: 'row',
    title: '可视化时间管理系统',
    full_title: '👀 我的可视化时间管理系统也太好用了！',
    description: '使用notion进行时间管理！',
    detail: '',
    pay: 3.5,
    cover: './assets/templates/temp-time.jpeg',
    pay_img: './assets/pay-img/pay-time.png',
    keywords: ['时间管理', '个人自律'],
    video: '//player.bilibili.com/player.html?aid=874199782&bvid=BV1SN4y1f7vD&cid=1285367808&p=1',
    m_pay_link: 'https://m.tb.cn/h.5Oe0671?tk=PrNmW4Z6yB9',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=741816175398',
  },
  {
    id: 37,
    direction: 'row',
    title: '自媒体新手必备的选题内容管理系统',
    description: '选题灵感 · 发布管理',
    cover: './assets/templates/temp-creator.jpeg',
    keywords: ['自媒体管理'],
    link: 'https://httishere666.notion.site/6d89c378d07e4af6aba6f5d7959d63c7?pvs=4',
  },
  {
    id: 36,
    direction: 'row',
    title: '积分制实现生活自律',
    full_title: '💯 成就感满分 ｜ 积分制实现生活自律 · 自律打卡 · 积分任务',
    description: '用积分自律生活',
    detail:
      '之前和大家分享过人生重启计划还有游戏式习惯养成的模版，大家都很习惯这种积分制还有游戏式的形式，所以今天和大家分享我一直在用的Notion 积分打卡模版。',
    pay: 4.5,
    cover: './assets/templates/temp-jifen.jpeg',
    pay_img: './assets/pay-img/pay-jifen.png',
    keywords: ['个人管理', '积分奖励'],
    video: '//player.bilibili.com/player.html?aid=958523742&bvid=BV1zp4y1A7PV&cid=1270142172&p=1',
    m_pay_link: 'https://m.tb.cn/h.5PelFl8?tk=OaP3W4Z3Js0',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=739304164440',
  },
  {
    id: 35,
    direction: 'row',
    title: '个人开学计划',
    full_title: '🎉 开学啦！！效率翻倍 · 用Notion规划自己的开学计划',
    description: '拥有自己的时间管理权',
    detail:
      '时间过得太快，马上又要迎来新的学期，不知道大家这个暑假有没有好好的完成假前设定的目标，从现在开始又可以设定新学期的规划了，让自己拥有自己的时间管理权，不要再让短视频，漫无目的的刷手机占据自己的生活，这里就是我设计的新学期规划，Notion的多重视图以及公式可以非常方便的满足我不同的管理需求。',
    pay: 3,
    cover: './assets/templates/temp-kaixue.jpeg',
    pay_img: './assets/pay-img/pay-kaixue.png',
    keywords: ['学习计划', '学生管理'],
    video: '//player.bilibili.com/player.html?aid=317896468&bvid=BV1BP411Y75U&cid=1252653130&p=1',
    m_pay_link: 'https://m.tb.cn/h.5PupbLN?tk=yhYMW4Z2Tha',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=736790123770',
  },
  {
    id: 34,
    direction: 'row',
    title: '月复盘 · 月计划',
    full_title: '👀 完全可视化｜用Notion做月复盘',
    description: '用数据说话 · 总结你的月执行',
    detail: '',
    pay: 15.9,
    cover: './assets/templates/temp-month.jpeg',
    pay_img: './assets/pay-img/pay-month.png',
    keywords: ['月度复盘', '自动化数据总结'],
    video: '//player.bilibili.com/player.html?aid=490338938&bvid=BV1cN411q7KD&cid=1247812047&p=1',
    m_pay_link: 'https://m.tb.cn/h.5Pun7hM?tk=QbLeW4Z16dl',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=735822305370',
    activity: '好评送模版',
  },
  {
    id: 33,
    direction: 'row',
    title: '个人图书馆',
    full_title: '🥰 强迫症福音｜Notion打造个人图书馆 · 阅读管理超好用！',
    description: '使用Notion打造自己的个人图书馆',
    detail:
      'Hello，大家好，这里是阿汪同学！</br>很多小伙伴和我一样都在使用Notion做自己的阅读管理，想要更好地记录和管理自己的进度和内容，所以今天和大家分享一下我是如何使用Notion打造自己的个人图书馆的！',
    pay: 6.8,
    cover: './assets/templates/temp-library.jpg',
    pay_img: './assets/pay-img/pay-library.png',
    keywords: ['阅读管理', '个人管理', '阅读摘录'],
    video: '//player.bilibili.com/player.html?aid=914560811&bvid=BV1Pu4y1z7og&cid=1227881724&p=1',
    m_pay_link: 'https://m.tb.cn/h.5Pu87GU?tk=xwIAW4aCXJG',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=733209071847',
  },
  {
    full_title: '😠 你的钱包是否被订阅服务绑架｜用Notion轻松管理你的订阅服务清单吧！',
    title: '订阅服务管理体系',
    description: '生活管理 · 财务管理',
    cover: './assets/templates/temp-dingyue.jpg',
    link: '',
    direction: 'row',
    pay: 3.5,
    keywords: ['生活管理'],
    detail:
      '随着订阅服务越来越多，经常会忘记一些自动续费项目，总是在被续费的时候才想起来，总之根本不清楚一个月到底在订阅服务上花费了多少。</br>这个模版就是帮助你来管理你的所有订阅服务，可以清晰地关注当前的订阅状态和到期状态。',
    video: '//player.bilibili.com/player.html?aid=914370555&bvid=BV1Nu4y1B7AK&cid=1221913565&p=1',
    pay_img: './assets/pay-img/pay-dingyue.png',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=732627011762',
    m_pay_link: 'https://m.tb.cn/h.5Pufzxl?tk=sZWUW4aHoci',
    id: 32,
  },
  {
    title: '2024公考全程计划',
    description: '复习进度 · 任务管理',
    cover: './assets/templates/temp-gongkao.jpg',
    link: 'https://httishere666.notion.site/Notion-ae8af3a3c8724842870381511056a95a?pvs=4',
    direction: 'row',
    pay: 0,
    id: 31,
  },
  {
    full_title: '🔥 下半年开始逆袭｜2023年下半年自律计划',
    title: '2023下半年逆袭计划',
    description: '开始自律 · 个人管理',
    cover: './assets/templates/temp-half.jpg',
    link: '',
    direction: 'row',
    pay: 6.8,
    keywords: ['半年计划', '个人管理', '复盘总结'],
    detail:
      '2023年已经过去一半，年初兴冲冲做的计划还在努力完成中，但是上半年的执行完成率真的有点低，所以希望能在下半年好好努力完成年初的目标。',
    video: '//player.bilibili.com/player.html?aid=315686144&bvid=BV1qP411C7PJ&cid=1190605112&page=1',
    pay_img: './assets/pay-img/pay-half.png',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=728711387658',
    m_pay_link: 'https://m.tb.cn/h.5b0KRDK?tk=6BZJdGer6uz',
    id: 30,
  },
  {
    full_title: '🎯 太酷啦！我用Notion做人生重启计划 · 奖励机制 · 人生清单',
    title: '游戏式人生重启计划',
    description: '本计划模版分成Web版和平板版。',
    cover: './assets/templates/temp-restart.jpg',
    link: '',
    direction: 'row',
    pay: 6.8,
    keywords: ['人生重启', '奖励机制', '人生清单'],
    detail:
      '之前有和大家分享过一个游戏式习惯养成的模版，有小伙伴有反映使用操作不方便，所以此模版也是在那个的基础上精简了操作让使用更方便！</br>所以，我最近想开始做我的人生“重启”计划，继续坚持我要做的事情，继续努力变成我想成为的人！</br>在这里我主要是分享这个计划的主要模块和思路，后续会更多和大家分享我的实际计划和行动，在这里我主要做的是计划和激励机制结合的方式。</br></br> 🔔 PS：本计划模版同样分成Web版和平板版，可以自行选择。',
    video: '//player.bilibili.com/player.html?aid=530558651&bvid=BV1Tu41187NC&cid=1184975904&page=1',
    pay_img: './assets/pay-img/pay-restart.png',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=727267424935',
    m_pay_link: 'https://m.tb.cn/h.5brA2rM?tk=aZgSdGenjnE',
    id: 29,
  },
  {
    full_title: '🫡 背书嘎嘎快！用Notion也能做艾宾浩斯遗忘曲线这也太酷啦！！',
    title: '艾宾浩斯遗忘曲线',
    description: '根据背诵时间自动计算下一次的学习日期。',
    cover: './assets/templates/temp-aibin.png',
    link: '',
    direction: 'row',
    pay: 2.5,
    keywords: ['艾宾浩斯', '学习提示'],
    detail:
      '在模版内可以创建需要背诵记忆的内容并选择开始时间，会根据开始时间和勾选背诵时间自动计算下一次的学习日期。</br>🫥 学习打卡表：切换为今日待学视图则会每日更新当天需要学习的内容。</br>🫥 学习打卡日历：会根据下次学习日期自动在日历上展示对应的内容。</br> 🫥 简单计时器：【Pro版】 还可以添加计时器自动汇总学习时长。',
    video: '//player.bilibili.com/player.html?aid=955416611&bvid=BV19s4y1F7HK&cid=1181882697&page=1',
    pay_img: './assets/pay-img/pay-aibin.png',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=726823988239',
    m_pay_link: 'https://m.tb.cn/h.50TREaa?tk=td8rdGen8kz',
    id: 28,
    has_specs: true,
    specs: [
      {
        title: '艾宾浩斯遗忘曲线',
        price: 2.5,
      },
      {
        title: '艾宾浩斯遗忘曲线 · 带计时器',
        price: 3.5,
      },
    ],
  },
  {
    full_title: '❗️ 告别拖延｜用Notion做极简又好用的todo list',
    title: '极简Todo list·带打卡',
    description: '用Notion做的超极简又好用的to do list。',
    cover: './assets/templates/temp-todo.JPG',
    link: '',
    direction: 'row',
    pay: 1.8,
    keywords: ['待办清单', '日程管理'],
    detail:
      '作为一个计划星人，看到满满的打勾就超级有成就感！</br>现在来分享一下我的模版主要内容吧～左侧是一个日历视图，在日历上可以看到所有的待办清单，右侧是一个周月日的待办列表。</br>最下面则是一个每月打卡（Pro版享有）。</br>你可以在日历上创建你的待办事项，它会自动显示在右侧对应的列表下，同理在右侧清单内创建任务也会被对应显示在日历内，事项上面只有一个勾选框用于表示任务是否完成。</br>最下面的月度打卡我分成了上下旬，创建打卡项目之后可以设定此区间的打卡目标值，打卡后会自动计算打卡进度，同时打卡项目上也会显示时间进度，便于你定位打卡位置。',
    video: '//player.bilibili.com/player.html?aid=785157545&bvid=BV1p14y127pd&cid=1175872668&page=1',
    pay_img: './assets/pay-img/pay-todo.png',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=726428167401',
    m_pay_link: 'https://m.tb.cn/h.5ZThkNq?tk=FK93dsFo0Du',
    id: 27,
  },
  {
    title: '极简好用的todo list',
    description: '待办清单日程管理',
    cover: './assets/templates/temp-todo.JPG',
    link: 'https://httishere666.notion.site/Todo-list-7d62c1b48f2b475d9d38541f2f44a3c7?pvs=4',
    direction: 'row',
    pay: 0,
    id: 26,
  },
  {
    full_title: '✈️ 趁年轻就现在·说走就走·旅行计划',
    title: '✈️ 旅行计划',
    description: '用Notion做的旅行计划，大家可以边走边记，趁年轻就现在！',
    cover: './assets/templates/temp-travel.png',
    link: '',
    direction: 'col',
    pay: 3.9,
    keywords: ['旅行计划', '说走就走'],
    detail:
      '我知道好多小伙伴都终于完成了高考，我想大家肯定都希望能趁这个最长的假期来一次说走就走的旅行再加上马上就要端午小假期，所以这里分享一下我用Notion做的旅行计划，大家可以边走边记，趁年轻就现在！',
    video: '',
    pay_img: './assets/pay-img/pay-travel.png',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=724405244780',
    m_pay_link: 'https://m.tb.cn/h.UzoXhRP?tk=llzUdreIuI5',
    id: 25,
  },
  {
    title: '2023 周计划·周复盘',
    description: '周目标 · 周打卡 · 周日程',
    cover: './assets/templates/temp-2023-week.jpg',
    link: 'https://httishere666.notion.site/3c9cc98320cf4e66bd82079968a5a086?pvs=4',
    direction: 'row',
    pay: 0,
    id: 21,
  },
  {
    full_title: '🫡 用Notion做英语外刊精读和TED学习也太好用了吧 · 生词表 · 文字注解',
    title: '外刊精读 | TED学习',
    description: '📔 学习任务日历 📔 学习计划看板 📔 生词记录表 📔 TED观看记录',
    cover: './assets/templates/temp-ted.jpg',
    link: '',
    direction: 'row',
    pay: 3.5,
    keywords: [],
    detail: '',
    video: '//player.bilibili.com/player.html?aid=570174570&bvid=BV1Zv4y177ne&cid=1101110022&page=1',
    pay_img: './assets/pay-img/pay-ted.png',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=722438640847',
    m_pay_link: 'https://m.tb.cn/h.UxQXJK8?tk=oZnXdKtrOwE',
    id: 24,
  },
  {
    full_title: '超实用｜专属自己的客户订单系统',
    title: 'CRM 客户订单系统',
    description: '求一个爆单',
    cover: './assets/templates/temp-crm.jpg',
    link: '',
    direction: 'row',
    pay: 6.8,
    keywords: ['CRM', 'OMS', '客户管理', '订单管理'],
    detail:
      '过去一段时间也陆陆续续有小伙伴找阿汪定制模版，我发现需要定制模版的大致分成了学习管理和销售管理两大块，再者我也需要对自己的定制订单进行管理，所以就设计了一个客户订单管理系统方便自己管理订单和给大家使用。<br>在这个客户订单管理系统内，我主要分成了订单管理，商品管理，客户管理和营收管理4大块。',
    video: '',
    pay_img: './assets/pay-img/pay-crm.png',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=719031223959',
    m_pay_link: 'https://m.tb.cn/h.UwGfzdE?tk=DtWidLNps0y',
    id: 23,
  },
  {
    title: '100件人生小事',
    description: '心之所向，行之所往',
    cover: './assets/templates/temp-100.jpg',
    link: 'https://httishere666.notion.site/b32e9afc456a4e67a078e08f9ed329e4?pvs=4',
    direction: 'col',
    pay: 0,
    id: 22,
  },
  {
    full_title: '🔥 超好用的14个Notion模版让你直接提高生产力',
    title: '🔥 2022模版合集',
    description: '包含个人管理，时间管理和财务管理',
    cover: './assets/templates/temp-14.jpg',
    link: '',
    direction: 'row',
    pay: 19.9,
    keywords: ['模版合集', '❗️ 附赠2023年度计划'],
    detail: '',
    video: '//player.bilibili.com/player.html?aid=952058656&bvid=BV14s4y1E787&cid=1083986968&page=1',
    pay_img: './assets/pay-img/2022-folder.png',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=722113870635',
    m_pay_link: 'https://m.tb.cn/h.Uxz0GSn?tk=uopQdpCIpwi',
    id: 20,
  },
  {
    full_title: '🎉 Notion 2024考研备考计划｜全程学习计划 · 每日打卡 · 考研倒计时',
    title: '🎉 2024考研备考计划',
    description: '全程学习计划 · 每日打卡 · 考研倒计时',
    cover: './assets/templates/temp-kaoyan.JPG',
    link: '',
    direction: 'col',
    pay: 4.5,
    keywords: ['考研倒计时', '考研信息', '科目汇总', '阶段任务', '月度打卡'],
    detail:
      'Hello，大家好，这里是阿汪同学。<br>大家都要开始准备考研复习了，我这里做了一个考研全程学习规划模版。<br>本模版功能丰富且可以永久使用！主要是为了让大家能更好的记录和自律！',
    video: '//player.bilibili.com/player.html?aid=909892811&bvid=BV1NM4y127kC&cid=1093787731&page=1',
    pay_img: './assets/pay-img/2024-kaoyan.png',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=713261159325',
    m_pay_link: 'https://m.tb.cn/h.Usl8qHp?tk=2IbPdlVoQaq',
    id: 18,
  },
  {
    title: '运动减肥计划',
    description: '体重曲线，运动记录，课程管理',
    cover: './assets/templates/temp-jianfei.jpg',
    link: 'https://httishere666.notion.site/2023-690059e53e854ed38cb524a564c2e2ab',
    direction: 'row',
    pay: 0,
    id: 19,
  },
  {
    full_title: '🔥 升级版｜史上最强Notion记账本模版 · 月度账单报表 · 月度汇总 · 资产管理',
    title: '🔥 2023记账本 Pro',
    description: '新增贷记账户管理，月度账单类别报表',
    cover: './assets/templates/temp-jizhang-pro.jpg',
    link: '',
    direction: 'row',
    pay: 7.5,
    keywords: ['月度类别报表', '贷记账户管理', '月度收支汇总', '资产管理', '多账户汇总', '收支分类管理'],
    detail:
      'Hello，大家好，这里是阿汪同学。前段时间和大家分享了我的Notion记账本，也收到了很多大家的反馈。所以在大家反馈的基础上进行了记账本的升级！！<br>新增功能介绍可看⬆️⬆️视频～<br><br>新增：<br>✅ 贷记账户管理<br>✅ 月度账单报表<br><br>整个模版内容：<br>🍊 月度支出折线图：需要自己去关联notion page进行制作，制作方法放在小破站和小🍠了<br>🍊 月度收支汇总：内有结余进度条和收支预算等数据<br>🍊 资产管理：可管理多个账户，每个账户会根据账单记录自动同步更新余额<br>🍊 日常账单记录：可选择账单分类，账户以及月份，都会自动进行数据汇总，还可进行账户间转账并不记录流水<br>🍊 收支分类：在分类内可查看分类下总体收支数据，还可查看单个分类的数据情况<br><br>⚠️ 对于之前已购买过记账本模版的小伙伴可以在TB联系我领取记账本Pro版！',
    video: '//player.bilibili.com/player.html?aid=268069345&bvid=BV1xY41167sm&cid=1041571465&page=1&high_quality=1&danmaku=0',
    pay_img: './assets/pay-img/jizhang-pro.png',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=706113541963',
    m_pay_link: 'https://m.tb.cn/h.UKYvsyQ?tk=aZY4dRknZAo',
    hot: true,
    id: 16,
    activity: '好评送模版',
  },
  {
    full_title: '🥳 太绝了！堪比APP的Notion记账本模版 · 日常账单 · 资产管理 · 月度汇总',
    title: '🔥 2023记账本',
    description: '月度汇总卡片，多账户管理，分类统计等',
    cover: './assets/templates/temp-jizhang.png',
    direction: 'row',
    pay: 4.5,
    keywords: ['月度收支汇总', '资产管理', '多账户汇总', '收支分类管理'],
    detail:
      '不用每次要打开各种各样的APP来进行记录，所以在之前财务管理的基础上又做了这个Notion记账本，可以管理自己的资产账户还有日常账单，数据汇总堪比APP！',
    video: '//player.bilibili.com/player.html?aid=394043580&bvid=BV1fd4y1E7jX&cid=999037020&page=1&high_quality=1&danmaku=0',
    pay_img: './assets/pay-img/jizhang.png',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=701368425851',
    m_pay_link: 'https://m.tb.cn/h.UmxKetH?tk=kPMtdhZEScj',
    hot: true,
    id: 15,
  },
  {
    full_title: '❌ 拒绝躺平摆烂｜我用Notion做2023年度计划体系·日程管理·任务管理·日常打卡',
    title: '🔥 2023年度计划',
    description: 'All in one，日程管理，目标进度等',
    cover: './assets/templates/temp-year-2023.png',
    direction: 'row',
    pay: 4.9,
    keywords: ['All in one', '日程管理', '目标进度', '日常打卡', '月度汇总', '100件小事', '阅读管理'],
    detail:
      '这是完全的All in one体系，可以作为新年年度计划使用，也可以作为主页体系使用哟！<br>在年度计划内包含了日程管理，目标管理，任务管理，阅读计划等等内容。<br>因为身体原因2022年实在是耽误了太多想做的事情，希望2023年一定要坚持完成计划的所有事，大家一起加油吧！',
    video: '//player.bilibili.com/player.html?aid=391996227&bvid=BV1Ud4y187U5&cid=943277776&page=1&high_quality=1&danmaku=0',
    pay_img: './assets/pay-img/2023-year.png',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=695932076909',
    m_pay_link: 'https://m.tb.cn/h.UlyK80f?tk=R3AddUs58W6',
    hot: true,
    id: 14,
  },
  {
    full_title: '像游戏闯关升级一样的自律计划·神仙Notion模版·让生活学习像游戏一样有趣',
    title: '🔥 游戏闯关自律计划',
    description: '技能升级，游戏闯关，奖品激励，任务打卡',
    cover: './assets/templates/game.png',
    direction: 'row',
    pay: 3.5,
    keywords: ['技能升级', '游戏闯关', '奖品激励', '任务打卡'],
    detail:
      '我之前有使用过Habitca这个App，感觉非常有意思，游戏化习惯养成，但是他不能自己设置奖品，我就想到了做一个这样子的个人激励计划。<br>🍃 🍃 游戏关卡<br>可以新增关卡并为关卡设置关卡奖品（可设置多个奖品），奖品价值就是本关通关需要获取的经验值，同时需要关联通关任务，任务可以是周期式的习惯打卡，也可以是单次待办任务。<br>',
    hot: true,
    video: '//player.bilibili.com/player.html?aid=261461631&bvid=BV1Re411579r&cid=859245697&page=1&high_quality=1&danmaku=0',
    pay_img: './assets/pay-img/youxi.png',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=690291631953',
    m_pay_link: 'https://m.tb.cn/h.UPe66m7?tk=5tR1dUs5FId',
    id: 13,
  },
  {
    full_title: '2023存钱计划财务规划 · 合理规划让我们一起早日成为小富婆',
    title: '🔥 2023年度财务规划',
    description: '财务规划，理财统计，52周存钱，36存单法',
    cover: './assets/templates/temp-finance.png',
    direction: 'row',
    pay: 3.0,
    keywords: ['财务规划', '理财统计', '52周存钱', '36存单法', '目标存', '收支状态'],
    detail:
      '▪️ 36存单法（强制存储）：根据实际情况提前设定要每个月需要强制存储的金额，然后将这笔资金分成3份，分别存成一年，两年和三年定期，那么在一年后每个月都会有一笔定期到期，形成存单循环。<br>▪️ 52周存钱法（零钱存）：设定一个每周递增金额，比如递增为10元，那么第一周存10元，第二周存20元，依次递增，将零钱存成大钱，用于急用。',
    video: '//player.bilibili.com/player.html?aid=521755370&bvid=BV1hM41117X3&cid=940508195&page=1&high_quality=1&danmaku=0',
    pay_img: './assets/pay-img/2023-caiwu.png',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=697322699493',
    m_pay_link: 'https://m.tb.cn/h.UOPV7Jw?tk=rlGmdgCkz8B',
    id: 12,
  },
  {
    full_title: '开学季新学期执行力UP UP，这份时间管理计划一定要收下，逆袭从现在开始',
    title: '🔥 学生党新学期计划',
    description: '学期目标，重点事件，任务清单，每周复盘，课程表，习惯追踪',
    cover: './assets/templates/new-term.jpg',
    direction: 'row',
    pay: 3.0,
    keywords: ['学期目标', '重点事件', '任务清单', '每周复盘', '课程表', '习惯追踪'],
    detail:
      '不想再浪费时间无效地过一个学期的学生党就一定要看看这份时间管理计划表！<br>整个学期计划主要分成学习，生活两大模块，左边主要是一些目标，重点事件，作业记录，体重记录，购物记录等条目，右侧是任务清单，每周复盘，课程表，习惯追踪，每日记账等。<br>在目标进度内，可根据自己需要设置相应的目标分类，子任务内可自动根据开始时间和完成时间计算相应的时长，且在主任务内会根据子任务的完成情况展示任务总时长和进度情况。',
    video: '//player.bilibili.com/player.html?aid=387818453&bvid=BV1ed4y1X739&cid=827794574&page=1&high_quality=1&danmaku=0',
    pay_img: './assets/pay-img/new-term.png',
    pay_link: 'https://item.taobao.com/item.htm?ft=t&id=690295786827',
    m_pay_link: 'https://m.tb.cn/h.Uk8HCPZ?tk=ehWAdUsvSFW',
    hot: true,
    id: 11,
  },
  {
    title: '2022年度复盘',
    description: '年度总结，生活碎片，年度榜单',
    cover: './assets/templates/temp-review-2022.png',
    link: '',
    direction: 'row',
    pay: 0,
    id: 10,
    lock: true,
  },
  {
    title: '每日打卡体系·睡眠曲线',
    description: '日常打卡，自动化生成打卡记录，计算睡眠时间',
    cover: './assets/templates/temp-tracker2.jpg',
    link: 'https://httishere666.notion.site/2022-905950e95b0e460ca7c2510903dd80a1?pvs=4',
    direction: 'row',
    pay: 0,
    id: 9,
  },
  {
    title: '高效日程时间管理',
    description: '日程管理，习惯打卡，时间管理，时间轴',
    cover: './assets/month-notion.jpeg',
    link: '',
    direction: 'row',
    pay: 0,
    id: 8,
    lock: true,
  },
  {
    title: '财务规划 & 存钱计划',
    description: '目标打卡，打卡明细，月度支出统计，大额支出记录，购物清单，财务整理',
    cover: './assets/caiwu.jpeg',
    link: '',
    direction: 'col',
    id: 7,
    lock: false,
  },
  {
    title: '个人积分打卡',
    description: '可以自定义打卡项目和分数，在日历内进行每日打卡，根据打卡自动汇总每月打卡情况',
    cover: './assets/jifen.jpeg',
    link: 'https://httishere666.notion.site/fcbdee6b2e3843818d61bd6978afc2cf?pvs=4',
    direction: 'row',
    id: 6,
  },
  {
    title: '2022 周计划',
    description: '周进度，周待办和本周任务完成进度，习惯打卡，睡眠记录和总结模块',
    cover: './assets/2022-week.jpeg',
    link: '',
    direction: 'col',
    id: 5,
    lock: true,
  },
  {
    title: '2022 健身计划',
    description: '年度目标，体测记录，阶段目标，每日饮食记录和健身记录',
    cover: './assets/jianshen.jpeg',
    link: '',
    direction: 'col',
    id: 4,
    lock: true,
  },
  {
    title: '存钱计划 & 理财周记',
    description: '只要不记账，我不在花钱就在花钱的路上，每日记账，每日统计，每周汇总。购物记录',
    cover: './assets/licai.jpeg',
    link: '',
    direction: 'col',
    id: 3,
    lock: true,
  },
  {
    title: '个人主页2.0',
    description: '信息展示，自我拓展，计划目标，工作日常，健康生活和生活琐事',
    cover: './assets/home2.0.jpeg',
    link: 'https://httishere666.notion.site/v2-0-1956472ec70c4a8d91db7ff1bd8f437f?pvs=4',
    direction: 'row',
    id: 2,
  },
  {
    title: '2022 年度计划',
    description: '包含年度目标列表，当前日历，当前年度数据概览（OKR），季度跟踪，月度计划，倒数日，其他计划（存钱，100件挑战，观影清单等）',
    cover: './assets/2022.jpeg',
    link: '',
    direction: 'col',
    id: 1,
    lock: true,
  },
]

export const PopularPicks: PickPreview[] = [
  {
    title: '生产力 UP UP！',
    tag: '个人知识体系',
    cover: './assets/ipad/knowledge.png',
    desc: [
      '欢迎您来到这个全新的模板。',
      '🧠 建立个人知识库 · 保持高效碎片化整理【我的第二大脑】',
      '在这个数字化信息不断涌现的时代，我们需要一个能够帮助我们管理和处理这些信息的有效工具。这就是我们的模板——“超级第二大脑”要做的。这个模板融入了PARA方法，提供了一种结构化的方式来管理您的信息。无论您是在管理个人目标、工作项目还是学术研究，这个系统都能够为您的生活中的每一个环节提供有序的支持。',
    ],
    btn: '开启你的头脑风暴吧 👉 👉',
    icon: '🧠',
    path: '/picks-detail/57',
  },
  {
    title: '可视化执行力Max',
    tag: '周计划复盘',
    cover: './assets/ipad/weekly.PNG',
    desc: [
      '欢迎您来到这个全新的模板。',
      '❌ 杀死拖延症 · 保持高效执行力的【我的可视化周计划复盘】',
      '✅ 周复盘体系主要分成了待办，每日打卡，积分打卡，专注计时等板块。通过高度的可视化可以帮助我们更好地提高执行力！',
      '在这里我们可以计划自己的日程内容，并在日看板形成完整的日程时间轴，还有必不可少的习惯打卡，通过热力表现让我们的打卡情况更加直观。更重要的是增加了时间管理模块，能让自己更清楚时间都花在哪儿了！',
    ],
    btn: '开启你的复盘计划吧 👉 👉',
    icon: '📅',
    path: '/picks-detail/68',
  },
  // {
  //   title: '史上最强财务模版！',
  //   tag: '记账体系',
  //   cover: './assets/ipad/finance.png',
  //   desc: [
  //     '欢迎您来到这个全新的模板。',
  //     '💰 打造All in one 可视化记账本【我的财务系统】',
  //     '使用该记账本模板，您可以轻松地记录每天的支出和收入情况，清晰地了解自己的财务状况。您可以根据自己的需求自定义记账本模板，添加或删除特定的分类，以便更好地管理您的财务。',
  //     '通过持续地记录和分析财务数据，您可以更好地了解自己的消费习惯，找到节省的空间，提高理财能力。',
  //   ],
  //   btn: '开启你的财务记录吧 👉 👉',
  //   icon: '💰',
  //   path: '#/picks-detail/57',
  // },
]
